<template>
    <div>
      <b-table
        responsive
        ref="table"
        :busy="isLoading"
        selectedVariant='link'
        selectable
        striped
        select-mode="single"
        :items="tableData"
        :fields="dataColumns"
        :tbody-tr-class="tableRow"
        :current-page="pagination.currentPage"
        show-empty
      >
        <template v-slot:empty="">
          <div class="text-center bd-secondary">
            <span>There's no data</span>
          </div>
        </template>
        <template v-slot:table-busy>
          <div class="text-center" style="margin: 3% auto;">
            <b-spinner small type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
            <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
          </div>
        </template>

        <template v-slot:head(status)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(minutes)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusVehicle)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusPayment)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusApprove)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusCompany)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusBranch)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusLeaveType)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusJobs)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusWork)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusLeave)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusPR)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusDepartment)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusPersonal)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <!-- <template v-slot:head(statusInvoice)="data">
          <div class="text-center">{{data.label}}</div>
        </template> -->
        <template v-slot:head(statusSales)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusReceipt)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(isRequired)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(actions)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(hour)="data">
          <div class="text-center" style="width:80px!important;">{{data.label}}</div>
        </template>
        <template v-slot:head(days)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(overtimeType)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(leaveType)="data">
          <div class="text-center" style="width:90px!important;">{{data.label}}</div>
        </template>
        <template v-slot:head(leaveQuota)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(reimburseType)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(phone)="data">
          <div class="text-left">{{data.label}}</div>
        </template>
        <template v-slot:head(type)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
         <template v-slot:head(geofence)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(isAvailable)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(quantity)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusRepaired)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <!-- <template v-slot:head(typeDate)="data">
          <div style="width:85px!important;">{{data.label}}</div>
        </template> -->
        <template v-slot:head(startDate)="data">
          <div class="text-center" style="width:80px!important;">{{data.label}}</div>
        </template>
        <template v-slot:head(endDate)="data">
          <div class="text-center" style="width:80px!important;">{{data.label}}</div>
        </template>
        <template v-slot:head(startTime)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(letterStartDate)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(letterEndDate)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(letterDate)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(endTime)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(stockInDate)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(actionsType)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(paidDateVehicle)="data">
          {{data.label}}
        </template>
        <template v-slot:head(updatedAt)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusRepair)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusType)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(statusTypeRepair)="data">
          <div class="text-center">{{data.label}}</div>
        </template>
        <template v-slot:head(createdAtType)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(worksheetFinishDate)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-slot:head(issuedBy)="data">
          <div>{{data.label}}</div>
        </template>
        <template v-for="customSlot in customSlots" :slot="customSlot.key" slot-scope="row">
          <slot :name="'content_' + customSlot.key" :row-data="row.item"/>
        </template>
        <template v-slot:cell(firstName)="row">
          {{row.item.firstName}} {{row.item.lastName}}
        </template>
        <template v-slot:cell(startDate)="row">
          <div class="text-center" style="width:80px!important;">
            {{row.item.startDate !== null ? getDate(row.item.startDate, "DD MMM YYYY") : '-'}}
          </div>
        </template>
        <template v-slot:cell(stockInDate)="row">
          <div class="text-center" style="width:80px!important;">
            {{row.item.stockInDate !== null ? getDate(row.item.stockInDate, "DD MMM YYYY") : '-'}}
          </div>
        </template>
        <template v-slot:cell(stockOutDate)="row">
          <div class="text-center" style="width:80px!important;">
            {{row.item.stockOutDate !== null ? getDate(row.item.stockOutDate, "DD MMM YYYY") : '-'}}
          </div>
        </template>
        <template v-slot:cell(purchaseDate)="row">
          <div class="text-center" style="width:80px!important;">
            {{row.item.purchaseDate !== null ? getDate(row.item.purchaseDate, "DD MMM YYYY") : '-'}}
          </div>
        </template>
        <template v-slot:cell(stockArea.areaName)="row">
          <div class="text-center" style="width:80px!important;">
            {{row.item.stockArea !== null ? row.item.stockArea.areaName : '-'}}
          </div>
        </template>
        <template v-slot:cell(endDate)="row">
          <div class="text-center" style="width:80px!important;">
            {{row.item.endDate !== null ? getDate(row.item.endDate, "DD MMM YYYY") : '-'}}
          </div>
        </template>
        <template v-slot:cell(dueDate)="row">
          {{row.item.dueDate !== null ? getDateTime(row.item.dueDate, "DD MMM YYYY") : '-'}}
        </template>
        <template v-slot:cell(yearTax)="row">
          {{row.item.yearTax !== null ? getDateTime(row.item.yearTax, "DD MMM YYYY") : '-'}}
        </template>
        <template v-slot:cell(paidDate)="row">
          {{row.item.paidDate !== null ? getDateTime(row.item.paidDate, "DD MMM YYYY") : '-'}}
        </template>
        <template v-slot:cell(paidDateVehicle)="row">
          {{row.item.paidDate !== null ? getDateTime(row.item.paidDate, "DD MMM YYYY") : '-'}}
        </template>
        <template v-slot:cell(invoiceStartDate)="row">
          {{row.item.paidDate !== null ? getDateTime(row.item.invoiceStartDate, "DD MMM YYYY") : '-'}}
        </template>
        <template v-slot:cell(userProfile)="row">
          <div style="width:150px!important;">
            {{row.item.userProfile.firstName}} {{row.item.userProfile.lastName}}
          </div>
        </template>
        <template v-slot:cell(account)="row">
          {{row.item.account.name !== null ? row.item.account.name : '-'}}
        </template>
        <template v-slot:cell(photo)="row">
          <a :href="row.item.photo" v-if="row.item.photo !== null"><font-awesome-icon icon="images"/> Look Image</a>
        <span v-else>-</span>
        </template>
        <template v-slot:cell(branchTimesheet)="row">
          <div style="width:100px!important;">
            {{row.item.userProfile.branch}}
          </div>
        </template>
        <template v-slot:cell(emailAccess)="row">
          {{row.item.userProfile.email !== null && row.item.userProfile.email !== undefined ? row.item.userProfile.email : '-'}}
        </template>
        <template v-slot:cell(fullNameAccess)="row">
          {{row.item.userProfile.firstName }} {{ row.item.userProfile.lastName }}
        </template>
        <!-- <template v-slot:cell(note)="row">
          {{row.item.note !== null ? row.item.note : '-'}}
        </template> -->
        <template v-slot:cell(notes)="row">
          {{row.item.note !== null && row.item.note !== '' && row.item.note !== 'null' && row.item.note !== undefined ? row.item.note : '-'}}
        </template>
        <!--<template v-slot:cell(telephone)="row">
          {{row.item.phone}} {{row.item.extPhone === '' ? '' : '- ' + row.item.extPhone}}
        </template>-->
        <template v-slot:cell(telephone)="row">
          {{row.item.phone !== null ? row.item.phone : '-'}}
        </template>
        <template v-slot:cell(address)="row">
          {{row.item.address !== null ? row.item.address : '-'}}
        </template>
        <template v-slot:cell(phone)="row">
          {{row.item.phone !== null ? row.item.phone : '-'}}
        </template>
        <template v-slot:cell(businessSector)="row">
          {{row.item.businessSector !== null || row.item.businessSector === 'null' ? row.item.businessSector.name : '-'}}
        </template>
        <template v-slot:cell(customerId)="row">
          {{row.item.customerId !== null && row.item.customerId !== '' ? row.item.customerId : '-'}}
        </template>
        <!-- <template v-slot:cell(supplierId)="row">
          {{row.item.supplierId !== null && row.item.supplierId !== '' ? row.item.supplierId : '-'}}
        </template> -->
        <template v-slot:cell(orderId)="row">
          {{row.item.orderId !== null && row.item.orderId !== '' ? row.item.orderId : '-'}}
        </template>
        <template v-slot:cell(salesPerson)="row">
          {{row.item.salesPerson !== null ? row.item.salesPerson.name : '-'}}
        </template>
        <template v-slot:cell(customer)="row">
          {{row.item.customer !== null && row.item.customer !== '' ? row.item.customer.name : '-'}}
        </template>
        <!-- <template v-slot:cell(supplier)="row">
          {{row.item.supplier !== null && row.item.supplier !== '' ? row.item.supplier.name : '-'}}
        </template> -->
        <template v-slot:cell(customerGroup)="row">
          {{row.item.customerCompany !== null ? row.item.customerCompany[0].company.name : '-' }}
        </template>
        <template v-slot:cell(username)="row">
          {{row.item.username !== null ? row.item.username : '-'}}
        </template>
        <template v-slot:cell(usernameAccess)="row">
          {{row.item.username !== null ? row.item.userProfile.username : '-'}}
        </template>
        <template v-slot:cell(departmentReimburse)="row">
          {{row.item.requestedBy !== null ? row.item.requestedBy.department : '-'}}
        </template>
        <template v-slot:cell(staffID)="row">
          {{row.item.username !== null ? row.item.username : '-'}}
        </template>
        <!-- <template v-slot:cell(requestedByEmployee)="row">
          <div :id="'name-tooltip-' + row.item.uuid">{{row.item.requestedBy !== null ? row.item.requestedBy.substring(0, 20) : '-'}}{{row.item.requestedBy !== null && row.item.requestedBy.length >= 20 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.requestedBy !== null && row.item.requestedBy.length >= 20" :target="'name-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.requestedBy}}
          </b-tooltip>
        </template> -->
        <template v-slot:cell(branch)="row">
          {{row.item.branch !== null ? row.item.branch.name : '-'}}
        </template>
        <template v-slot:cell(company)="row">
          {{row.item.company !== null ? row.item.company.name : '-'}}
        </template>
        <template v-slot:cell(department)="row">
          {{row.item.department !== null ? row.item.department.name : '-'}}
        </template>
        <template v-slot:cell(branchDepartment)="row">
          {{row.item.branch !== null ? row.item.branch.name : '-'}}
        </template>
        <template v-slot:cell(customerSales)="row">
          <div :id="'name-tooltip-' + row.item.uuid">{{row.item.customer.name !== null ? row.item.customer.name.substring(0, 15) : '-'}}{{row.item.customer.name !== null && row.item.customer.name.length >= 15 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.customer.name !== null && row.item.customer.name.length >= 15" :target="'name-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.customer.name}}
          </b-tooltip>
        </template>
        <template v-slot:cell(requestedByVehicle)="row">
          {{row.item.drivenBy !== null ? row.item.drivenBy : '-'}}
        </template>
        <template v-slot:cell(requestedBySales)="row">
          <div :id="'person-tooltip-' + row.item.uuid">{{row.item.requestedBy.name !== null ? row.item.requestedBy.name.substring(0, 12) : '-'}}{{row.item.requestedBy.name !== null && row.item.requestedBy.name.length >= 12 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.requestedBy.name !== null && row.item.requestedBy.name.length >= 12" :target="'person-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.requestedBy.name}}
          </b-tooltip>
        </template>
        <template v-slot:cell(requestedByName)="row">
          <div :id="'name-tooltip-' + row.item.uuid">{{row.item.requestedBy.name !== null ? row.item.requestedBy.name.substring(0, 20) : '-'}}{{row.item.requestedBy.name !== null && row.item.requestedBy.name.length >= 20 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.requestedBy.name !== null && row.item.requestedBy.name.length >= 20" :target="'name-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.requestedBy.name}}
          </b-tooltip>
        </template>
        <template v-slot:cell(requestedByEmployee)="row">
          <div :id="'name-tooltip-' + row.item.uuid">{{row.item.requestedBy !== null ? row.item.requestedBy.substring(0, 20) : '-'}}{{row.item.requestedBy !== null && row.item.requestedBy.length >= 20 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.requestedBy !== null && row.item.requestedBy.length >= 20" :target="'name-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.requestedBy}}
          </b-tooltip>
        </template>
        <template v-slot:cell(address)="row">
          <div :id="'address-tooltip-' + row.item.uuid">{{row.item.address !== '' ? row.item.address.substring(0, 45) : '-'}}{{row.item.address !== '' && row.item.address.length >= 45 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.address !== '' && row.item.address.length >= 45" :target="'address-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.address}}
          </b-tooltip>
        </template>
        <template v-slot:cell(name)="row">
          <div :id="'address-tooltip-' + row.item.uuid">{{row.item.name !== '' ? row.item.name.substring(0, 45) : '-'}}{{row.item.name !== '' && row.item.name.length >= 45 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.name !== '' && row.item.name.length >= 45" :target="'address-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.name}}
          </b-tooltip>
        </template>
        <template v-slot:cell(requestedByDepartment)="row">
          <div :id="'department-tooltip-' + row.item.uuid">{{row.item.requestedBy.department !== '' ? row.item.requestedBy.department.substring(0, 12) : '-'}}{{row.item.requestedBy.department !== '' && row.item.requestedBy.department.length >= 12 ? '...' : ''}}</div>
          <b-tooltip v-if="row.item.requestedBy.department !== '' && row.item.requestedBy.department.length >= 12" :target="'department-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.requestedBy.department}}
          </b-tooltip>
        </template>
        <template v-slot:cell(purchaseItem)="row">
          <div v-for="(item, i) in row.item.purchaseItem" :key="i">
            <p>{{ item.itemList !==null ? item.itemList.name : '-'}}</p>
          </div>
          <!-- <div :id="'department-tooltip-' + row.item.uuid">{{row.item.purchaseItem.itemList !== '' ? row.item.purchaseItem.itemList.substring(0, 12) : '-'}}{{row.item.purchaseItem.itemList !== '' && row.item.purchaseItem.itemList.length >= 12 ? '...' : ''}}</div> -->
          <!-- <b-tooltip v-if="row.item.requestedBy.department !== '' && row.item.requestedBy.department.length >= 12" :target="'department-tooltip-' + row.item.uuid" placement="bottom">
            {{row.item.requestedBy.department}}
          </b-tooltip> -->
        </template>
        <template v-slot:cell(requestedBy)="row">
          {{row.item.requestedBy !== null ? row.item.requestedBy.name || row.item.requestedBy : '-'}}
        </template>
        <template v-slot:cell(departmentUser)="row">
          {{row.item.department.name !== null ? row.item.department.name : '-'}}
        </template>
        <template v-slot:cell(leaveQuota)="row">
          <div class="text-center">
            {{row.item.leaveQuota !== null ? row.item.leaveQuota : '-'}}
          </div>
        </template>
        <template v-slot:cell(vehiclePlate)="row">
          <div style="width:75px!important;">
            {{row.item.vehicle.plate}}
          </div>
        </template>
        <template v-slot:cell(vehicle)="row">
          {{row.item.vehicle.merk}} {{row.item.vehicle.model}}
        </template>
        <template v-slot:cell(category)="row">
          {{row.item.category.name}}
        </template>
        <template v-slot:cell(startTime)="row">
          <div style="width:140px!important;">
            {{row.item.startTime !== null ? getDate(row.item.startTime) : '-'}}
          </div>
        </template>
        <template v-slot:cell(endTime)="row">
          <div style="width:140px!important;">
            {{row.item.endTime !== null ? getDate(row.item.endTime) : '-'}}
          </div>
        </template>
        <template v-slot:cell(note)="row">
          <div :id="'tooltip-button-' + row.item.uuid">
            {{row.item.note !== null ? row.item.note.substring(0, 30) : '-'}}
            {{row.item.note !== null && row.item.note.length >= 30 ? '...' : ''}}
          </div>
          <b-tooltip v-if="row.item.note !== null && row.item.note.length >= 30" :target="'tooltip-button-' + row.item.uuid" placement="bottom">
            {{row.item.note}}
          </b-tooltip>
        </template>
        <template v-slot:cell(subject)="row">
          <div :id="'tooltip-button-' + row.item.uuid">
            {{row.item.subject !== null ? row.item.subject.substring(0, 20) : '-'}}
            {{row.item.subject !== null && row.item.subject.length >= 15 ? '...' : ''}}
          </div>
          <b-tooltip v-if="row.item.subject !== null && row.item.subject.length >= 10" :target="'tooltip-button-' + row.item.uuid" placement="bottom">
            {{row.item.subject}}
          </b-tooltip>
        </template>
        <!-- <template v-slot:cell(name)="row">
          <div :id="'tooltif-button-' + row.item.uuid">
            {{row.item.name !== null ? row.item.name.substring(0, 30) : '-'}}
            {{row.item.name !== null && row.item.name.length >= 30 ? '...' : ''}}
          </div>
          <b-tooltip v-if="row.item.name !== null && row.item.name.length >= 30" :target="'tooltif-button-' + row.item.uuid" placement="bottom">
            {{row.item.name}}
          </b-tooltip>
        </template> -->
        <template v-slot:cell(noteRepair)="row">
          <div :id="'tooltip-button-' + row.item.uuid">
            {{row.item.repair.note !== null ? row.item.repair.note.substring(0, 30) : '-'}}
            {{row.item.repair.note !== null && row.item.repair.note.length >= 30 ? '...' : ''}}
          </div>
          <b-tooltip v-if="row.item.repair.note !== null && row.item.repair.note.length >= 30" :target="'tooltip-button-' + row.item.uuid" placement="bottom">
            {{row.item.repair.note}}
          </b-tooltip>
        </template>
        <template v-slot:cell(notes)="row">
          <div :id="'tooltip-button-' + row.item.uuid">
            {{row.item.note !== null && row.item.note !== '' && row.item.note !== 'null' ? row.item.note.substring(0, 50) : '-'}}
            {{row.item.note.length >= 50 ? '...' : ''}}
          </div>
          <b-tooltip v-if="row.item.note !== null && row.item.note.length >= 50" :target="'tooltip-button-' + row.item.uuid" placement="bottom">
            {{row.item.note}}
          </b-tooltip>
        </template>
        <template v-slot:cell(overtimeType)="row">
          <div class="text-center">
            {{row.item.overtimeType !== null ? row.item.overtimeType.name : '-'}}
          </div>
        </template>
        <template v-slot:cell(city)="row">
          {{row.item.city !== null ? row.item.city : '-'}}
        </template>
        <template v-slot:cell(state)="row">
          {{row.item.state !== null ? row.item.state : '-'}}
        </template>
        <template v-slot:cell(issuedByRepair)="row">
          {{row.item.repair.issuedBy !== null ? row.item.repair.issuedBy : '-'}}
        </template>
        <template v-slot:cell(statusRepaired)="row">
          <div class="text-center">
            <b-badge :variant="getStatusTypeColor(row.item.repair.status)">{{getStatusName(row.item.repair.status)}}</b-badge>
          </div>
        </template>
         <template v-slot:cell(geofence)="row">
          <div class="text-center">
            {{getStatusNameGeofence(row.item.geofence)}}
          </div>
        </template>
        <template v-slot:cell(isOffDay)="row">
          <div class="">
            {{getStatusNameGeofence(row.item.isOffDay)}}
          </div>
        </template>
        <template v-slot:cell(billNumber)="row">
          {{row.item.billNumber !== null && row.item.billNumber !== 'null' ? row.item.billNumber : '-'}}
        </template>
        <!-- <template v-slot:cell(typeDate)="row">
          {{row.item.options !== null && row.item.options !== 'null' ? row.item.options[0].value : '-'}}
        </template> -->
        <template v-slot:cell(serviceDate)="row">
          {{row.item.options !== null ? row.item.options[0].value : '-'}}
        </template>
        <template v-slot:cell(timezone)="row">
          {{row.item.timezone !== null ? row.item.timezone : '-'}}
        </template>
        <template v-slot:cell(hour)="row">
          <div class="text-center" style="width:80px!important;">
            {{row.item.hour !== null ? row.item.hour : '-'}}
          </div>
        </template>
        <template v-slot:cell(days)="row">
          <div class="text-center">
            {{row.item.days !== null ? formatDays(row.item.days) : '-'}}
          </div>
        </template>
        <template v-slot:cell(letterStartDate)="row">
          <div class="text-center" style="width:90px!important;">
            {{row.item.letterStartDate !== null ? getDate(row.item.letterStartDate) : '-'}}
          </div>
        </template>
        <template v-slot:cell(letterEndDate)="row">
          <div class="text-center" style="width:90px!important;">
            {{row.item.letterEndDate !== null ? getDate(row.item.letterEndDate) : '-'}}
          </div>
        </template>
        <template v-slot:cell(letterDate)="row">
          <div class="text-center" style="width:90px!important;">
            {{row.item.letterDate !== null ? getDate(row.item.letterDate) : '-'}}
          </div>
        </template>
        <template v-slot:cell(leaveType)="row">
          <div class="text-center" style="width:90px!important;">
            {{row.item.leaveType !== null ? row.item.leaveType.name : '-'}}
          </div>
        </template>
        <template v-slot:cell(minutes)="row">
          <div class="text-center">
            {{row.item.minutes !== null ? row.item.minutes : '-'}}
          </div>
        </template>
        <template v-slot:cell(quota)="row">
          {{row.item.quota !== null ? formatDays(row.item.quota) : '-'}}
        </template>
        <template v-slot:cell(isAvailable)="row">
          <div class="text-center">
            <b-badge :variant="getColorCompany(row.item.isAvailable)">{{getStatusQrcode(row.item.isAvailable)}}</b-badge>
          </div>
        </template>
        <template v-slot:cell(type)="row">
          <div class="text-center">
            {{row.item.type !== null && row.item.type !== undefined ? row.item.type : '-'}}
          </div>
        </template>
        <template v-slot:cell(isOutstation)="row">
          <div class="" v-if="row.item.isOutstation">
        <font-awesome-icon icon="check" style="margin-top:4px!important;font-size:12px!important;"></font-awesome-icon>
          </div>
          <div v-else class="">
            -
          </div>
        </template>
        <template v-slot:cell(clockInTime)="row">
          <div class="">
            {{row.item.clockInTime !== null ? getTime(row.item.clockInTime) : '-'}}
          </div>
        </template>
         <template v-slot:cell(leave)="row">
          <div class="">
            {{row.item.leave > 0 ? row.item.leave : '-'}}
          </div>
        </template>
        <template v-slot:cell(clockOutTime)="row">
          <div class="">
            {{row.item.clockOutTime !== null ? getTime(row.item.clockOutTime) : '-'}}
          </div>
        </template>
        <template v-slot:cell(breakInTime)="row">
          <div class="">
            {{row.item.breakInTime !== null ? getTime(row.item.breakInTime) : '-'}}
          </div>
        </template>
        <template v-slot:cell(breakOutTime)="row">
          <div class="">
            {{row.item.breakOutTime !== null ? getTime(row.item.breakOutTime) : '-'}}
          </div>
        </template>
         <template v-slot:cell(totalMinutesLate)="row">
          <div class="">
            {{row.item.totalMinutesLate > 0 ? row.item.totalMinutesLate + ' menit' : '-'}}
          </div>
        </template>
        <template v-slot:cell(reimburseType)="row">
          <div class="text-center">
            {{row.item.reimburseType !== null ? row.item.reimburseType.name : '-'}}
          </div>
        </template>
        <template v-slot:cell(isRequired)="row">
          <div class="text-center">
            <b-badge :variant="getStatusColor(row.item.isRequired)">{{getStatusName(row.item.isRequired)}}</b-badge>
          </div>
        </template>
        <template v-slot:cell(status)="row">
          <div class="text-center">
            <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status}}</b-badge>
          </div>
        </template>
        <template v-slot:cell(isHq)="row">
            <b-badge title="Headquarters" :variant="getColorCompany(row.item.isHq)">{{getStatusCompany(row.item.isHq)}}</b-badge>
        </template>
        <template v-slot:cell(statusType)="row">
          <div class="text-center">
            <b-badge :variant="getStatusTypeColor(row.item.status)">{{getStatusTypeName(row.item.status)}}</b-badge>
          </div>
        </template>
        <template v-slot:cell(statusTypeRepair)="row">
          <div class="text-center">
            <b-badge :variant="getStatusTypeColor(row.item.status)">{{getStatusTypeRepair(row.item.status)}}</b-badge>
          </div>
        </template>
        <template v-slot:cell(statusPersonal)="row">
          <div class="text-center">
            <b-badge :variant="getStatusColor(row.item.leave.status)">{{getStatusName(row.item.leave.status)}}</b-badge>
          </div>
        </template>
        <!-- <template v-slot:cell(statusInvoice)="row">
          <div class="text-center">
            <b-badge :variant="getStatusColor(row.item.status)">{{getStatusName(row.item.status)}}</b-badge>
          </div>
        </template> -->
        <template v-slot:cell(statusRepair)="row">
          <div class="text-center">
            <b-badge :variant="getStatusColor(row.item.status)">{{getStatusName(row.item.status)}}</b-badge>
          </div>
        </template>
        <template v-slot:cell(createdAt)="row">
          <div style="width:140px!important;">
            {{row.item.createdAt !== null ? getDate(row.item.createdAt) : '-'}}
          </div>
        </template>
        <template v-slot:cell(worksheetFinishDate)="row">
          <div style="width:140px!important;">
            {{row.item.worksheetFinishDate !== null ? getDate(row.item.worksheetFinishDate) : '-'}}
          </div>
        </template>
        <template v-slot:cell(createdAtType)="row">
            {{row.item.createdAt !== null ? getDate(row.item.createdAt) : '-'}}
        </template>
        <template v-slot:cell(issuedBy)="row">
          {{row.item.issuedBy !== null ? row.item.issuedBy : '-'}}
        </template>
        <template v-slot:cell(approvedBy)="row">
            {{row.item.approvedBy !== null ? row.item.approvedBy : '-'}}
        </template>
        <template v-slot:cell(updatedAt)="row">
          <div class="text-center">
          {{row.item.updatedAt !== null ? getDate(row.item.updatedAt) : '-'}}
          </div>
        </template>
        <template v-slot:cell(orderDate)="row">
          {{row.item.orderDate !== null ? getDate(row.item.orderDate) : '-'}}
        </template>
        <template v-slot:cell(quantity)="row">
          <div class="text-center">
          {{row.item.quantity !== null ? row.item.quantity : '-'}}
          </div>
        </template>
        <template v-slot:cell(price)="row">
          {{ dataAccount.account.currency }} {{row.item.price !== null ? formatPrice(row.item.price) : '-'}}
        </template>
        <template v-slot:cell(amount)="row">
          {{ dataAccount.account.currency }} {{row.item.amount !== null ? formatPrice(row.item.amount) : '-'}}
        </template>
        <template v-slot:cell(amounts)="row">
          {{ dataAccount.account.currency }} {{row.item.amount !== null ? formatPrice(row.item.amount) : '-'}}
        </template>
        <template v-slot:cell(normalPrice)="row">
          {{ dataAccount.account.currency }} {{row.item.amount !== null ? formatPrice(row.item.normalPrice) : '-'}}
        </template>
        <template v-slot:cell(corporatePrice)="row">
          {{ dataAccount.account.currency }} {{row.item.amount !== null ? formatPrice(row.item.corporatePrice) : '-'}}
        </template>
        <template v-slot:cell(invoiceTotal)="row">
          {{ dataAccount.account.currency }} {{row.item.amount !== null ? formatPrice(row.item.invoiceTotal) : '-'}}
        </template>
        <template v-slot:cell(invoicePaymentTotal)="row">
          {{ dataAccount.account.currency }} {{row.item.amount !== null ? formatPrice(row.item.invoicePaymentTotal) : '-'}}
        </template>
        <template v-slot:cell(purchaseUnpaidBill)="row">
          {{ dataAccount.account.currency }} {{row.item.purchaseUnpaidBill !== null ? formatPrice(row.item.purchaseUnpaidBill) : 0}}
        </template>
        <template v-slot:cell(purchaseTotal)="row">
          {{ dataAccount.account.currency }} {{row.item.purchaseTotal !== null ? formatPrice(row.item.purchaseTotal) : 0}}
        </template>
        <template v-slot:cell(purchaseTotalPayment)="row">
          {{ dataAccount.account.currency }} {{row.item.purchaseTotalPayment !== null ? formatPrice(row.item.purchaseTotalPayment) : 0}}
        </template>
        <template v-slot:cell(invoiceUnpaidBill)="row">
          {{ dataAccount.account.currency }} {{row.item.amount !== null ? formatPrice(row.item.invoiceUnpaidBill) : '-'}}
        </template>
        <template v-slot:cell(typeDate)="row">
          {{row.item.dueDate !== null ? getDate(row.item.dueDate) : '-'}}
        </template>
        <!-- <template v-slot:cell(typeDate)="row">
          <div class="text-center">
          {{row.item.options !== null ? getDate(row.item.options[0].value) : '-'}}
          </div>
        </template> -->
        <!--<template v-slot:cell(statusSales)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? row.item.status : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === 'Requested'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Change Status</template>
                <b-button title="Reject" variant="danger" size="sm" class="btn-reject-popover mr-2 float-left" @click="showModal('reject',row.item)"><font-awesome-icon icon="times-circle"></font-awesome-icon> Reject</b-button>
                <b-button title="Approve" variant="success" size="sm" class="btn-approve-popover float-right" @click="showModalSales('approve',row.item)"><font-awesome-icon icon="check-circle"></font-awesome-icon> Approve</b-button>
              </b-popover>
            </template>
          </div>
        </template>-->
        <template v-slot:cell(statusReceipt)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? row.item.status : '-'}}</b-badge>
            </div>
          </div>
        </template>
        <template v-slot:cell(statusPayment)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? getNameLeave(row.item.status) : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === 'Requested'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Change Status</template>
                <b-button title="Reject" variant="danger" size="sm" class="btn-reject-popover mr-2 float-left" @click="showModal('reject',row.item)"><font-awesome-icon icon="times-circle"></font-awesome-icon> Reject</b-button>
                <b-button title="Approve" variant="success" size="sm" class="btn-approve-popover float-right" @click="showModal('approve',row.item)"><font-awesome-icon icon="check-circle"></font-awesome-icon> Approve</b-button>
              </b-popover>
            </template>
            <template v-if="row.item.status === 'Approved'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Approved By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:green!important;" class="mt-0 mb-0"> {{row.item.approvedBy !== null ? row.item.approvedBy : '-'}}</p>
              </b-popover>
            </template>
            <template v-if="row.item.status === 'Rejected'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Rejected By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:red!important;" class="mt-0 mb-0"> {{row.item.rejectedBy !== null ? row.item.rejectedBy : '-'}}</p>
              </b-popover>
            </template>
          </div>
        </template>
        <template v-slot:cell(statusLeave)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? getNameLeave(row.item.status) : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === 'Approved'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Approved By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:green!important;" class="mt-0 mb-0"> {{row.item.approvedBy !== null ? row.item.approvedBy : '-'}}</p>
              </b-popover>
            </template>
            <template v-if="row.item.status === 'Rejected'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Rejected By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:red!important;" class="mt-0 mb-0"> {{row.item.rejectedBy !== null ? row.item.rejectedBy : '-'}}</p>
              </b-popover>
            </template>
          </div>
        </template>
        <template v-slot:cell(statusJobs)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusJobsColor(row.item.status)">{{row.item.status !== null ? getStatusJobsName(row.item.status) : '-'}}</b-badge>
            </div>
          </div>
        </template>

        <template v-slot:cell(statusWork)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusWorksColor(row.item.status)">{{row.item.status !== null ? row.item.status : '-'}}</b-badge>
            </div>
          </div>
        </template>

        <template v-slot:cell(purchaseStatus)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.purchaseStatus)">{{row.item.purchaseStatus !== null ? row.item.purchaseStatus : '-'}}</b-badge>
            </div>
          </div>
        </template>

        <template v-slot:cell(statusInvoice)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? row.item.status : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === 'Created'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Created By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:green!important;" class="mt-0 mb-0"> {{row.item.createdBy !== null ? row.item.createdBy.firstName + ' ' + row.item.createdBy.lastName : '-'}}</p>
              </b-popover>
            </template>
            <template v-if="row.item.status === 'Submited'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Rejected By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:red!important;" class="mt-0 mb-0"> {{row.item.submitedBy !== null ? row.item.submitedBy : '-'}}</p>
              </b-popover>
            </template>
            <template v-if="row.item.status === 'Canceled'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Canceled By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:red!important;" class="mt-0 mb-0"> {{row.item.submitedBy !== null ? row.item.submitedBy : '-'}}</p>
              </b-popover>
            </template>
          </div>
        </template>
        <template v-slot:cell(statusPR)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? row.item.status : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === 'Approved'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Last Approval By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:green!important;" class="mt-0 mb-0"> {{row.item.lastApproval !== null ? row.item.lastApproval : '-'}} <label style="margin:0px!important; font-size: 14px!important; color:black!important;"> ({{ row.item.position !== null ? row.item.position : '-' }})</label></p>
              </b-popover>
            </template>
            <template v-if="row.item.status === 'Rejected'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Rejected By</template>
                <p style="font-weight:bold!important; font-size: 14px!important; color:red!important;" class="mt-0 mb-0"> {{row.item.rejectedBy !== null ? row.item.rejectedBy : '-'}} <label style="margin:0px!important; font-size: 14px!important; color:black!important;">({{ row.item.position !== null ? row.item.position : '-' }})</label></p>
              </b-popover>
            </template>
          </div>
        </template>
        <template v-slot:cell(statusApprove)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? row.item.status : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === 'Approved' && row.item.status !== 'Requested'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Change Status</template>
                <b-button variant="primary" size="sm" class="btn-pay-popover" @click="showModalPay('',row.item)"><font-awesome-icon icon="donate"></font-awesome-icon> Pay</b-button>
              </b-popover>
            </template>
          </div>
        </template>
        <template v-slot:cell(statusVehicle)="row">
          <div class="text-center">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? getStatusName(row.item.status) : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === '0' && row.item.status !== '1'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Change Status</template>
                <!-- <p style="font-weight:bold!important; font-size: 12px!important; color:black!important;" class="mt-1 mb-2"> Requested By: <label style="color:green!important; font-weight:bold!important;">{{row.item.requestedBy !== null ? row.item.requestedBy : '-'}}</label></p> -->
                <b-button variant="success" size="sm" class="btn-approve-popover" v-model="row.item.status" @click="doChangeStatusAvailable([row.item.uuid, row.item.status])"><font-awesome-icon icon="check-circle"></font-awesome-icon> Available</b-button>
              </b-popover>
            </template>
            <template v-if="row.item.status === '1' && row.item.status !== '0'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="bottom">
                <template v-slot:title>Change Status</template>
                <b-button variant="danger" size="sm" class="btn-reject-popover" v-model="row.item.status" @click="doChangeStatusNotAvailable([row.item.uuid, row.item.status])"><font-awesome-icon icon="times-circle"></font-awesome-icon> Not Available</b-button>
              </b-popover>
            </template>
          </div>
        </template>
        <template v-slot:cell(statusLeaveType)="row">
          <div class="text-center">
            <b-form-checkbox name="check-button" switch size="lg" v-model="row.item.isActive" title="Active" @change="changeLeaveType([row.item.uuid, row.item.isActive])"></b-form-checkbox>
          </div>
        </template>
        
        <template v-slot:cell(statusCompany)="row">
          <div class="text-center">
            <b-form-checkbox name="check-button" switch size="lg" v-model="row.item.isActive" title="Active" @change="changeSwitch([row.item.uuid, 'company', row.item.isActive])"></b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(statusBranch)="row">
          <div class="text-center">
            <b-form-checkbox name="check-button" switch size="lg" v-model="row.item.isActive" title="Active" @change="changeSwitch([row.item.uuid, 'branch', row.item.isActive])"></b-form-checkbox>
          </div>
        </template>
        <!--<template v-slot:cell(statusHq)="row">
          <template v-if="row.item.company.isHq === 'true'">
            <b-badge :variant="getColorCompany(row.item.company.isHq)">{{getStatusCompany(row.item.company.isHq)}}</b-badge>
          </template>
        </template>-->
        <template v-slot:cell(statusDepartment)="row">
          <div class="text-center">
            <b-form-checkbox name="check-button" switch size="lg" v-model="row.item.isActive" title="Active" @change="changeSwitch([row.item.uuid, 'department', row.item.isActive])"></b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(statusPersonal)="row">
          <div class="text-center">
            <b-form-checkbox name="check-button" switch size="lg" v-model="row.item.isActive" title="Active" @change="changeSwitch([row.item.uuid, 'personal', row.item.isActive])"></b-form-checkbox>
          </div>
        </template>
        <template v-slot:cell(actionSales)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
            <template v-if="hasRole(['Supervisor', 'Admin', 'Manager']) && row.item.status === 'Requested'">
              <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
              <a v-if="canReject" v-b-tooltip.hover.top title="Reject" class="text-danger" style="font-size:22px;" @click="showModal('reject',row.item)">
                <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
              </a>
              <a v-if="canApprove" v-b-tooltip.hover.topright title="Approve" class="text-success" style="font-size:22px;" @click="showModalSales('approve', row.item)">
                <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
              </a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionQuotation)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
            <!-- v-if="hasRole(['Supervisor', 'Admin', 'Manager']) && row.item.status === 'Issued'" -->
            <template>
              <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
              <!-- <a v-if="canReject" v-b-tooltip.hover.top title="Reject" class="text-danger" style="font-size:22px;" @click="showModal('reject',row.item)">
                <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
              </a> -->
              <!-- <a v-if="canApprove" v-b-tooltip.hover.topright title="Approve" class="text-success" style="font-size:22px;" @click="showModal('approve', row.item)">
                <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
              </a> -->
            </template>
          </div>
        </template>
        <template v-slot:cell(actionsReimburse)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/new-reimbursement/general' + '/' + row.item.uuid"></a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionRepaired)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/vehicle' + '/' + row.item.uuid"></a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionTypes)="row">
          <div class="text-center">
            <template v-if="canEditModal">
              <a v-if="canEditModal" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1" @click="doEdit(row.item)"></a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionStockIn)="row">
          <div class="text-center">
            <template v-if="canEdit">
              <a v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-2" :href="'#/inventory/stock-in' + '/' + row.item.uuid + '/edit'"></a>
            </template>
              <a v-b-tooltip.hover.bottom title="Details" class="btn-op icon-info mr-1" :href="'#/inventory/stock-in' + '/' + row.item.uuid"></a>
              <a v-if="canDelete" v-b-tooltip.hover.topright  v-on:click.stop.prevent="doDeleteData(row.item.uuid)" title="Delete" class="btn-op icon-delete ml-1"></a>
          </div>
        </template>
         <template v-slot:cell(actionStockOut)="row">
          <div class="text-center">
            <template v-if="canEdit">
              <a v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-2" :href="'#/inventory/stock-out' + '/' + row.item.uuid + '/edit'"></a>
            </template>
              <a v-b-tooltip.hover.bottom title="Details" class="btn-op icon-info mr-1" :href="'#/inventory/stock-out' + '/' + row.item.uuid"></a>
              <a v-if="canDelete" v-b-tooltip.hover.bottom  v-on:click.stop.prevent="doDeleteData(row.item.uuid)" title="Delete" class="btn-op icon-delete ml-1"></a>
          </div>
        </template>

        <!-- ************** JOURNAL TABLE **************** -->
         <template v-slot:cell(actionJournal)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
            <template v-if="row.item.journalReferenceType === 'J'">
              <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
              <a v-if="canDelete" v-b-tooltip.hover.topright  v-on:click.stop.prevent="doDeleteData(row.item.uuid)" title="Delete" class="btn-op icon-delete ml-1"></a>
              <a v-if="canApprove" v-b-tooltip.hover.topright title="Approve" class="text-success" style="font-size:22px;" @click="showModalSales('approve', row.item)">
                <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
              </a>
            </template>
          </div>
        </template>
         <template v-slot:cell(journalNumberTransaction)="row">
          <div class="text-left">
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'KSIN'" :href="'#' + '/accounting/cash-in' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'KASO'" :href="'#' + '/accounting/cash-out' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'KASTR'" :href="'#' + '/accounting/cash-transfer' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'STI'" :href="'#' + '/inventory/stock-in' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'STO'" :href="'#' + '/inventory/stock-out' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'R'" :href="'#' + '/new-reimbursement/history-reimbursement' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'PO'" :href="'#' + '/inventory/purchase' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'DO'" :href="'#' + '/sales/delivery-order' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'INV'" :href="'#' + '/sales/invoice' + '/' + row.item.journalReferenceUuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
            <b-link class="ml-2 text-primary text-bold" v-if="row.item.journalReferenceType === 'J'" :href="'#' + '/accounting/journal' + '/' + row.item.uuid">
              {{row.item.journalNumberTransaction !== null ? row.item.journalNumberTransaction : '-'}}
            </b-link>
          </div>
        </template>

        <template v-slot:cell(journalDate)="row">
          {{row.item.journalDate !== null ? getDateTime(row.item.journalDate, "DD MMM YYYY") : '-'}}
        </template>

        <template v-slot:cell(code)="row">
          <div v-for="code in row.item.journalTransaction" :key="code.i">
            <p>{{code.journalAccount.journalAccountCode !== null ? code.journalAccount.journalAccountCode : '-'}}</p>
          </div>
        </template>

         <template v-slot:cell(journalName)="row">
          <div v-for="name in row.item.journalTransaction" :key="name.i">
            <p>{{name.journalAccount.journalAccountName !== null ? name.journalAccount.journalAccountName : '-'}}</p>
          </div>
        </template>

         <template v-slot:cell(journalTransactionNote)="row">
          <div v-for="name in row.item.journalTransaction" :key="name.i">
            <p>
              {{name.journalTransactionNote !== null ? name.journalTransactionNote.substring(0, 30) : '-'}}
              {{name.journalTransactionNote !== null && name.journalTransactionNote.length >= 30 ? '...' : ''}}
            </p>
            <b-tooltip v-if="name.journalTransactionNote !== null && name.journalTransactionNote.length >= 30" :target="'tooltip-button-' + row.item.uuid" placement="bottom">
              {{name.journalTransactionNote}}
            </b-tooltip>
          </div>
        </template>

         <template v-slot:cell(journalTransactionDebit)="row">
          <div v-for="name in row.item.journalTransaction" :key="name.i">
            <p>
            {{ dataAccount.account.currency }} {{name.journalTransactionDebit !== null ? formatPrice(name.journalTransactionDebit) : '-'}}
            </p>
          </div>
        </template>

        <template v-slot:cell(journalTransactionCredit)="row">
          <div v-for="name in row.item.journalTransaction" :key="name.i">
            <p>
            {{ dataAccount.account.currency }} {{name.journalTransactionCredit !== null ? formatPrice(name.journalTransactionCredit) : '-'}}

            </p>
          </div>
        </template>
        <!-- =========================================================== -->

        <!-- ============ CASH OUT TABLE ============== -->
         <template v-slot:cell(actionCashOut)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
            <template>
              <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
              <a v-if="canDelete" v-b-tooltip.hover.topright  v-on:click.stop.prevent="doDeleteDataCash(row.item.uuid)" title="Delete" class="btn-op icon-delete ml-1"></a>
            </template>
          </div>
        </template>

        <template v-slot:cell(cashDate)="row">
          {{row.item.cashDate !== null ? getDateTime(row.item.cashDate, "DD MMM YYYY") : '-'}}
        </template>

         <template v-slot:cell(transactionJournalCode)="row">
          <div v-for="code in row.item.cashTransaction" :key="code.i">
            <p>{{code.journalAccount.journalAccountCode !== null ? code.journalAccount.journalAccountCode : '-'}}</p>
          </div>
        </template>

        <template v-slot:cell(transactionJournalAccount)="row">
          <div v-for="code in row.item.cashTransaction" :key="code.i">
            <p>{{code.journalAccount.journalAccountName !== null ? code.journalAccount.journalAccountName : '-'}}</p>
          </div>
        </template>

        <template v-slot:cell(transactionNote)="row">
          <div v-for="name in row.item.cashTransaction" :key="name.i">
            <p>
              {{name.cashTransactionNote !== null ? name.cashTransactionNote.substring(0, 30) : '-'}}
              {{name.cashTransactionNote !== null && name.cashTransactionNote.length >= 30 ? '...' : ''}}
            </p>
            <b-tooltip v-if="name.cashTransactionNote !== null && name.cashTransactionNote.length >= 30" :target="'tooltip-button-' + row.item.uuid" placement="bottom">
              {{name.cashTransactionNote}}
            </b-tooltip>
          </div>
        </template>

         <template v-slot:cell(transactionDebit)="row">
          <div v-for="name in row.item.cashTransaction" :key="name.i">
            <p>
            {{ dataAccount.account.currency }} {{name.cashTransactionDebit !== null ? formatPrice(name.cashTransactionDebit) : '-'}}
            </p>
          </div>
        </template>

        <template v-slot:cell(transactionCredit)="row">
          <div v-for="name in row.item.cashTransaction" :key="name.i">
            <p>
            {{ dataAccount.account.currency }} {{name.cashTransactionCredit !== null ? formatPrice(name.cashTransactionCredit) : '-'}}

            </p>
          </div>
        </template>

        <!-- ============ END CASHOUT TABLE =========== -->

           <!-- ============ CASH IN TABLE ============== -->
         <template v-slot:cell(actionCashIn)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
            <template>
              <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
              <a v-if="canDelete" v-b-tooltip.hover.topright  v-on:click.stop.prevent="doDeleteDataCash(row.item.uuid)" title="Delete" class="btn-op icon-delete ml-1"></a>
            </template>
          </div>
        </template>

        <template v-slot:cell(cashDate)="row">
          {{row.item.cashDate !== null ? getDateTime(row.item.cashDate, "DD MMM YYYY") : '-'}}
        </template>

         <!-- <template v-slot:cell(transactionJournalCode)="row">
          <div v-for="code in row.item.cashTransaction" :key="code.i">
            <p>{{code.journalAccount.journalAccountCode !== null ? code.journalAccount.journalAccountCode : '-'}}</p>
          </div>
        </template> -->

        <!-- <template v-slot:cell(transactionJournalAccount)="row">
          <div v-for="code in row.item.cashTransaction" :key="code.i">
            <p>{{code.journalAccount.journalAccountName !== null ? code.journalAccount.journalAccountName : '-'}}</p>
          </div>
        </template> -->

        <!-- <template v-slot:cell(transactionNote)="row">
          <div v-for="name in row.item.cashTransaction" :key="name.i">
            <p>
              {{name.cashTransactionNote !== null ? name.cashTransactionNote.substring(0, 30) : '-'}}
              {{name.cashTransactionNote !== null && name.cashTransactionNote.length >= 30 ? '...' : ''}}
            </p>
            <b-tooltip v-if="name.cashTransactionNote !== null && name.cashTransactionNote.length >= 30" :target="'tooltip-button-' + row.item.uuid" placement="bottom">
              {{name.cashTransactionNote}}
            </b-tooltip>
          </div>
        </template> -->

         <!-- <template v-slot:cell(transactionDebit)="row">
          <div v-for="name in row.item.cashTransaction" :key="name.i">
            <p>
            {{ dataAccount.account.currency }} {{name.cashTransactionDebit !== null ? formatPrice(name.cashTransactionDebit) : '-'}}
            </p>
          </div>
        </template> -->

        <!-- <template v-slot:cell(transactionCredit)="row">
          <div v-for="name in row.item.cashTransaction" :key="name.i">
            <p>
            {{ dataAccount.account.currency }} {{name.cashTransactionCredit !== null ? formatPrice(name.cashTransactionCredit) : '-'}}

            </p>
          </div>
        </template> -->

        <!-- ============ END CASHIN TABLE =========== -->
        <!-- <template v-slot:cell(actionsInvoice)="row">
          <div class="text-center">
            <template v-if="canView">
              <a v-b-tooltip.hover.left @click="showModalInvoice(row.item.path)" title="Canceled" class="btn-op icon-times-circle px-2"><b-avatar variant="danger" size="1.15em"></font-awesome-icon></b-avatar></a>
            </template>
            <template v-if="canShow">
              <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path +'/' + row.item.uuid"></a>
            </template>
            <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
          </div>
        </template> -->
        <!-- =========================================================== -->
        <template v-slot:cell(actionsQrcode)="row">
          <div class="text-center">
            <template v-if="canView">
              <a v-b-tooltip.hover.left @click="showQRCode(row.item.path)" title="View" class="btn-op px-2"><b-avatar variant="info" size="1.35em"><font-awesome-icon icon="qrcode" style="margin-top:4px!important;font-size:12px!important;"></font-awesome-icon></b-avatar></a>
            </template>
            <template v-if="canDownload">
              <a v-b-tooltip.hover.left @click="doDownloadQRcode(row.item.path)" title="Download" class="btn-op px-2"><b-avatar variant="info" size="1.35em"><font-awesome-icon icon="download" style="margin-top:4px!important;font-size:11px!important;"></font-awesome-icon></b-avatar></a>
            </template>
            <template v-if="canPrint">
              <a v-b-tooltip.hover.top @click="doPrintQRcode(row.item.path)" title="Print" class="btn-op px-0"><b-avatar variant="secondary" size="1.35em"><font-awesome-icon icon="print" style="margin-top:4px!important; font-size:11px!important;"></font-awesome-icon></b-avatar></a>
            </template>
          </div>
        </template>
        <!--<template v-slot:cell(statusPenalty)="row">
            <div :id="'btn-popover-' + row.item.uuid">
              <b-badge :variant="getStatusColor(row.item.status)">{{row.item.status !== null ? row.item.status : '-'}}</b-badge>
            </div>
            <template v-if="row.item.status === 'New' && row.item.status !== 'Paid'">
              <b-popover :target="'btn-popover-' + row.item.uuid" triggers="hover" placement="left">
                <template v-slot:title>Change Status</template>
                <b-button variant="primary" size="sm" class="btn-pay-popover" @click="showModal('pay',row.item)"><font-awesome-icon icon="donate"></font-awesome-icon> Pay</b-button>
              </b-popover>
            </template>
        </template>-->
        <!-- <template v-slot:cell(actionsType)="row">
          <div class="text-center">
            <template v-if="modalView">
              <b-button variant="primary" size="sm" @click="doEdit([row.uuid])" class="mb-0 text-center edit"><i class="fas fa-pencil-alt"></i></b-button>
            </template>
          </div>
        </template> -->
        <template v-slot:cell(roleAccess)="row">
          <div class="text-center">
            <b-form-select name="role-access" size="sm" v-model="row.item.userRole.uuid" :options="roleList" @change="changeRole([row.item.uuid, row.item.userProfile.uuid, row.item.userRole.uuid])" />
          </div>
        </template>
        <template v-slot:cell(actionAccess)="row">
          <div class="text-center">
            <b-button v-if="canRemove" variant="light" size="sm" v-on:click.stop.prevent="doDeleteAccess(row.item.uuid)" style="color:#1976D2!important; font-weight:bolder!important;">{{$t('remove')}}</b-button>
          </div>
        </template>
        <template v-slot:cell(actionLeaves)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>

            <template v-if="hasRole(['Supervisor', 'Admin']) && row.item.status !== 'Approved' && row.item.status !== 'Rejected' && row.item.status !== 'Canceled'">
                <a v-if="canReject" v-b-tooltip.hover.top title="Reject" class="text-danger" style="font-size:22px;" @click="showModalLeaves('reject',row.item)">
                  <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
                <a v-if="canApprove" v-b-tooltip.hover.topright title="Approve" class="text-success" style="font-size:22px;" @click="showModalLeaves('approve', row.item)">
                  <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionLeaveIndex)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>

            <template v-if="hasRole(['Supervisor', 'Admin', 'Manager']) && row.item.status !== 'Approved' && row.item.status !== 'Rejected' && row.item.status !== 'Canceled'">
                <a v-if="canReject" v-b-tooltip.hover.top title="Reject" class="text-danger" style="font-size:22px;" @click="showLeavesModal('reject',row.item)">
                  <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
                <a v-if="canApprove" v-b-tooltip.hover.topright title="Approve" class="text-success" style="font-size:22px;" @click="showLeavesModal('approve', row.item)">
                  <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionOvertimes)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>

            <template v-if="hasRole(['Supervisor', 'Admin']) && row.item.status !== 'Approved' && row.item.status !== 'Rejected' && row.item.status !== 'Canceled'">
                <a v-if="canReject" v-b-tooltip.hover.top title="Reject" class="text-danger" style="font-size:22px;" @click="showModalOvertime('reject',row.item)">
                  <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
                <a v-if="canApprove" v-b-tooltip.hover.topright title="Approve" class="text-success" style="font-size:22px;" @click="showModalOvertime('approve', row.item)">
                  <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionInvoice)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>

            <template v-if="row.item.status === 'CREATED' | row.item.status === 'UNPAID'">
                <a v-if="canReject && row.item.status !== 'PAID'" v-b-tooltip.hover.top title="Canceled" class="text-danger" style="font-size:22px;" @click="showModalInvoice(row.item)">
                  <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template>
            <!-- <template v-if="row.item.status === 'CREATED' | row.item.status === 'UNPAID'">
                <a v-if="canApprove" v-b-tooltip.hover.topright title="PAID" class="text-success" style="font-size:22px;" @click="showModalInvoicePaid(row.item)">
                  <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template> -->
                <template v-if="row.item.status === 'CREATED' | row.item.status === 'UNPAID'">
                <a v-if="canApprove" v-b-tooltip.hover.topright title="PAY" class="text-success" style="font-size:22px;" @click="showModalInvoicePay(row.item)">
                  <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
                </a>
                </template>
                <template>
                <!-- <a v-if="canApprove && row.item.status == 'CANCELED'" v-b-tooltip.hover.topright title="PAY" class="text-success" style="font-size:22px;" @click="showModalInvoicePay(row.item)">
                  <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
                </a> -->
                </template>
          </div>
        </template>
        <template v-slot:cell(actionPurchase)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/' + 'inventory/purchase' + '/' + row.item.uuid"></a>
            </template>
            <template v-if="row.item.purchaseStatus == 'CREATED'">
             <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#/' + 'inventory/purchase/' + row.item.uuid + '/edit'"></a>
            </template>
              
             <template>
                <a v-if="canApprove" v-b-tooltip.hover.topright title="PAY" class="text-success" style="font-size:22px;" @click="showModalPurchasePay(row.item)">
                  <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
                </a>
             </template>

            <!-- <template v-if="row.item.status === 'CREATED' | row.item.status === 'UNPAID'">
                <a v-if="canReject && row.item.status !== 'PAID'" v-b-tooltip.hover.top title="Canceled" class="text-danger" style="font-size:22px;" @click="showModalInvoice(row.item)">
                  <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template> -->
            <!-- <template v-if="row.item.status === 'CREATED' | row.item.status === 'UNPAID'">
                <a v-if="canApprove" v-b-tooltip.hover.topright title="PAID" class="text-success" style="font-size:22px;" @click="showModalInvoicePaid(row.item)">
                  <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template> -->
                <!-- <template v-if="row.item.status === 'CREATED' | row.item.status === 'UNPAID'">
                <a v-if="canApprove" v-b-tooltip.hover.topright title="PAY" class="text-success" style="font-size:22px;" @click="showModalInvoicePay(row.item)">
                  <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
                </a>
                </template> -->
                <template>
                <!-- <a v-if="canApprove && row.item.status == 'CANCELED'" v-b-tooltip.hover.topright title="PAY" class="text-success" style="font-size:22px;" @click="showModalInvoicePay(row.item)">
                  <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
                </a> -->
                </template>
          </div>
        </template>
        <template v-slot:cell(actionWorksheet)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#/worksheet/' + row.item.uuid"></a>
              <!-- <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/'  + row.item.uuid"></a> -->
            </template>
          </div>
        </template>
        <template v-slot:cell(actionReceiptIndex)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'receipt/item/' + row.item.uuid "></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
            <template v-if="row.item.status === 'Created' | row.item.status === 'CREATED'">
              <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
            </template>
            <template v-if="row.item.status === 'Created' | row.item.status === 'CREATED'">
              <a v-if="canReject" v-b-tooltip.hover.top title="Cancel" class="text-danger" style="font-size:22px;" @click="showModalReceipt(row.item)">
                  <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionCategoryReimburst)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'/reimbursement/category-reimbursement/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actionRepair)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'/vehicle/repair-detail/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left title="Details" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="text-center">
            <template v-if="canShow">
              <a v-if="canShowRoutePath" v-b-tooltip.hover.left :title="$t('detail')" class="btn-op icon-info mr-1" :href="canShowRoutePath + '/' + row.item.uuid"></a>
              <a v-else v-b-tooltip.hover.left :title="$t('detail')" class="btn-op icon-info mr-1" :href="'#' + $route.path + '/' + row.item.uuid"></a>
            </template>

            <template v-if="hasRole(['Supervisor', 'Admin', 'Manager']) && row.item.status !== 'Approved' && row.item.status !== 'Rejected' && row.item.status !== 'Canceled'">
                <a v-if="canReject" v-b-tooltip.hover.top title="Reject" class="text-danger" style="font-size:22px;" @click="showModal('reject',row.item)">
                  <font-awesome-icon icon="times-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
                <a v-if="canApprove" v-b-tooltip.hover.topright title="Approve" class="text-success" style="font-size:22px;" @click="showModal('approve', row.item)">
                  <font-awesome-icon icon="check-circle" style="padding-top:6px;"></font-awesome-icon>
                </a>
            </template>

            <a v-if="canEdit" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1 ml-1" :href="'#' + $route.path + '/' + row.item.uuid + '/edit'"></a>
            <template v-if="row.item.status === 'New' && row.item.status !== 'Paid'">
              <a v-if="canEditModal" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1" @click="doEdit(row.item)"></a>
            </template>
            <template v-if="row.item.status === 'New' && row.item.status !== 'Paid'">
              <a v-if="canEditPenalty" v-b-tooltip.hover.bottom title="Edit" class="btn-op icon-edit mr-1" @click="doEdit(row.item)"></a>
            </template>
            <a v-if="canDelete" v-b-tooltip.hover.topright  v-on:click.stop.prevent="doDeleteData(row.item.uuid)" title="Delete" class="btn-op icon-delete ml-1"></a>
            <template v-if="row.item.status === 'New'">
              <a v-if="canPaid" v-b-tooltip.hover.top title="Pay" class="text-primary" style="font-size:22px;" @click="showModalTypePay(row.item.type, row.item)">
                <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
              </a>
            </template>
            <template v-if="row.item.status === 'New'">
              <a v-if="canRepair" v-b-tooltip.hover.top title="Pay" class="text-primary" style="font-size:22px;" @click="showModalPayRepair(row.item.type, row.item)">
                <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
              </a>
            </template>
            <template v-if="row.item.status === 'CREATED'">
              <a v-if="canRepair" v-b-tooltip.hover.top title="Pay" class="text-primary" style="font-size:22px;" @click="showModalPayInvoice(row.item.type, row.item)">
                <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
              </a>
            </template>
            <template v-if="row.item.status === 'PAID'">
              <a v-if="canRepair" v-b-tooltip.hover.top title="Pay" class="text-primary" style="font-size:22px;" @click="showModalPayInvoice(row.item.type, row.item)">
                <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
              </a>
            </template>
            <template v-if="row.item.status === 'Unpaid'">
              <a v-if="canRepair" v-b-tooltip.hover.top title="Pay" class="text-primary" style="font-size:22px;" @click="showModalPayInvoice(row.item.type, row.item)">
                <font-awesome-icon icon="donate" style="padding-top:6px;"></font-awesome-icon>
              </a>
            </template>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2" v-if="pagination.total > dataLimit">
        <div class="col-md-6 pr-0">
        <span class="card-category"
          >Showing {{ from + 1 }} to {{ to }} of
          {{ pagination.total }} entries</span
        >
        </div>
        <b-col sm="6" md="6" class="my-1 pl-0">
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.total"
          :per-page="dataLimit"
          align="fill"
          size="sm"
          class="my-0 float-right"
        ></b-pagination>
        </b-col>
      </b-row>
      <b-modal id="bv-modal-payment" hide-footer>
        <template v-slot:modal-title>
            <h5 class="text-transform">{{type}} {{name}}</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatus(type)">
            <template v-if="type==='Paid'">
              <div class="d-block">
                  <label for=""><strong>Note</strong></label>
                  <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter note"></b-form-textarea>
              </div>
            </template>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-payment')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <b-modal id="bv-modal-type" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Repair Payment</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatusType(type)">
          <template>
            <div class="d-block">
              <label for="">Bill Number *</label>
              <b-form-input v-model="formData.billNumber" required placeholder="Enter Bill Number"></b-form-input><br>
              <label for="">Amount *</label>
              <b-form-input v-model="formData.amount" required placeholder="Enter Amount"></b-form-input><br>
              <label for="">Vehicle Bill Photo *</label>
              <div class="expander">
                <b-form-file :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="formData.photoBill1">
                </b-form-file>
              </div><br>
              <label for="">Note</label>
              <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-type')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <!-- ===================== -->

        <b-modal id="bv-modal-invoice-pay" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Invoice Payment</h5>
        </template>
        <form v-on:submit.prevent="doPaymentInvoice()">
          <template>
            <div class="d-block">
              <label for="">Payment Date *</label>
               <div class="form-group" v-bind:class="errors.has('date') ? 'has-error':''">
                  <b-form-datepicker
                    data-vv-as="date"
                    name="date"
                    v-bind:class="errors.has('date') ? 'is-invalid':''"
                    v-validate="'required'"
                    required
                    type="date"
                    class="form-control"
                    v-model="formData.paymentDate"
                    placeholder="Date"
                  />
                  <p v-if="errors.has('date') !== null"></p>
                  </div>
              <label for="">Payment Ref Number</label>
              <b-form-input v-model="formData.paymentRefNumber" placeholder="Ref number .."></b-form-input><br>
              <label for="">Payment To *</label>
              <b-form-select :options="bankList" required
                  v-model="formData.paymentTo"
                ></b-form-select>
              <!-- <v-select
                id="mySelect"
                label="text"
                v-model="formData.paymentTo"
                :options="bankList"
                :reduce="(text) => text.value"
                class="style-chooser"
                placeholder="select bank account"
              ></v-select> -->
               <label class="mt-2" for="">Payment Ammount *</label>
                <money
                    v-bind="money"
                    v-model="formData.paymentAmmount"
                    required
                    class="form-control text-right small-text"
                    style="margin-top:15px!important; width: 50%;"
                    placeholder="Price"
                  /> <br>
              <!-- <b-form-input type="number" v-model="formData.paymentAmmount" required placeholder="Enter Amount"></b-form-input><br> -->
              <label for="">Photo</label>
              <b-form-file placeholder="Payment Receipt" v-model="formData.paymentReceipt" />
              <br>

              <label class="mt-2" for="">Note</label>
              <b-form-textarea rows="3" v-model="formData.paymentNote" placeholder="Enter Note"></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-invoice-pay')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          <b-button variant="primary" v-if="formData.paymentAmmount > 0" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>

      <!-- ===================== -->

      <!-- ===================== -->

        <b-modal id="bv-modal-purchase-pay" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Purchase Payment</h5>
        </template>
        <form v-on:submit.prevent="doPaymentPurchase()">
          <template>
            <div class="d-block">
              <label for="">Payment Date *</label>
               <div class="form-group" v-bind:class="errors.has('date') ? 'has-error':''">
                  <b-form-datepicker
                    data-vv-as="date"
                    name="date"
                    v-bind:class="errors.has('date') ? 'is-invalid':''"
                    v-validate="'required'"
                    required
                    type="date"
                    class="form-control"
                    v-model="formData.paymentDate"
                    placeholder="Date"
                  />
                  <p v-if="errors.has('date') !== null"></p>
                  </div>
              <label for="">Payment Ref Number</label>
              <b-form-input v-model="formData.paymentRefNumber" placeholder="Ref number .."></b-form-input><br>
              <label for="">Payment To *</label>
              <b-form-select :options="bankList" required
                  v-model="formData.paymentTo"
                ></b-form-select>
             
               <label class="mt-2" for="">Payment Ammount *</label>
                <money
                    v-bind="money"
                    v-model="formData.paymentAmmount"
                    required
                    class="form-control text-right small-text"
                    style="margin-top:15px!important; width: 50%;"
                    placeholder="Price"
                  /> <br>
               <label for="">Photo</label>
              <b-form-file placeholder="Payment Receipt" v-model="formData.paymentReceipt" />
              <br>
              <label class="mt-2" for="">Note</label>
              <b-form-textarea rows="3" v-model="formData.paymentNote" placeholder="Enter Note"></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-purchase-pay')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          <b-button variant="primary" v-if="formData.paymentAmmount > 0" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>

      <!-- ===================== -->

      <b-modal id="bv-modal-example" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">{{type}} {{name}}</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatus(type)">
          <template>
            <div class="d-block">
              <label for="" class="labels">Note</label>
              <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-example')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <b-modal id="bv-modal-invoice" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Change Status</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatusInvoice()">
          <template>
            <div class="d-block">
               <!-- <label for="" class="labels">Status</label> -->
              <!-- <b-form-select rows="3" v-model="formData.status" :options="statusList" placeholder="Enter Note"></b-form-select> -->
              <label for="" class="labels">Note</label>
              <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-invoice')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <b-modal id="bv-modal-receipt" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Change Status</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatusReceipt()">
          <template>
            <div class="d-block text-center">
              <h4>Are you sure?</h4>
              <p> You will cancel the Delivery Order Request!</p>
              
            </div>
          </template>
          <a class="mt-4 btn btn-outline-warning" @click="$bvModal.hide('bv-modal-receipt')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</a>
          <b-button variant="danger" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="check" v-else></font-awesome-icon> OK</b-button>
        </form>
      </b-modal>
      <b-modal id="bv-modal-leaves" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">{{type}} Leave</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatusLeaves(type)">
          <template>
            <div class="d-block">
              <label for="" class="labels">Note</label>
              <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-leaves')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <b-modal id="bv-modal-leaves-index" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">{{type}} Leave</h5>
          <!-- <h5 class="text-transform">{{type}} Leave ({{formData.name}})</h5> -->
        </template>
        <form v-on:submit.prevent="doLeavesChangeStatus(type)">
          <template>
            <div class="d-block">
              <!-- <label for="" class="labels">Leave Request</label>
              <b-form-input v-model="formData.days" readonly id="field-type"></b-form-input><br>-->
              <!-- <label for="" class="labels">Exceed Quota of Leave</label>
              <b-form-input v-model="formData.quotaExceed" readonly id="field-type"></b-form-input><br> -->
              <label for="" class="labels">Note</label>
              <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
            </div>
          </template>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-leaves-index')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
          <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <b-modal id="bv-modal-overtimes" hide-footer>
        <template v-slot:modal-title>
            <h5 class="text-transform">{{type}} Overtime</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatusOvertime(type)">
            <template>
              <div class="d-block">
                  <label for=""><strong>Note</strong></label>
                  <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter note"></b-form-textarea>
              </div>
            </template>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-overtimes')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <b-modal id="bv-modal-sales" hide-footer>
        <template v-slot:modal-title>
            <h5 class="text-transform">{{type}} {{name}}</h5>
        </template>
        <form v-on:submit.prevent="doDeliverySales(type)">
            <template>
              <div class="d-block">
                <label for=""><strong>Delivery Date </strong></label>
                <b-form-datepicker v-model="formData.deliveryDate" placeholder="Enter Delivery Date"></b-form-datepicker>
                <label for="" class="mt-3"><strong>Note</strong></label>
                <b-form-textarea rows="3" v-model="formData.note" placeholder="Enter Note"></b-form-textarea>
              </div>
            </template>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-sales')"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>
      <!--<b-modal id="bv-modal-payment" hide-footer>
        <template v-slot:modal-title>
            <h5 class="text-transform">{{type}} {{name}}</h5>
        </template>
        <form v-on:submit.prevent="doChangeStatusPay()">
            <div class="d-block">
                <label for=""><strong>Requested By</strong></label>
                <b-form-input v-model="formData.requestedBy" placeholder="Enter requested by"></b-form-input>
                <label for="" class="mt-4"><strong>Start Date</strong></label>
                <b-form-datepicker v-model="formData.startDate" placeholder="Enter start date"></b-form-datepicker>
                <label for="" class="mt-4"><strong>End Date</strong></label>
                <b-form-datepicker v-model="formData.endDate" placeholder="Enter end date"></b-form-datepicker>
            </div>
            <b-button class="mt-4" @click="$bvModal.hide('bv-modal-payment')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button>
            <b-button variant="primary" type="submit" class="mt-4 float-right"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button>
        </form>
      </b-modal>-->
    </div>
</template>
<script>
  import saveAs from 'file-saver'
  import {Money} from 'v-money'

  export default {
    components: {Money},
    props: {
      dataUrl: {
        type: String,
        required: true
      },
      deleteUrl: {
        type: String,
        required: false,
        default: null
      },
      dataKey: {
        type: String,
        required: true
      },
      dataColumns: {
        type: Array,
        required: true
      },
      dataOrderField: {
        type: String,
        default: 'createdAt'
      },
      dataOrderAsc: {
        type: Number,
        default: 0
      },
      dataLimit: {
        type: Number,
        default: 25
      },
      dataParams: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      },
      modalView: {
        type: Boolean,
        required: false,
        default: false
      },
      defaultDataParams: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      },
      canShow: {
        type: Boolean,
        required: false,
        default: true
      },
      canShowRoutePath: {
        type: String,
        required: false,
        default: ''
      },
      canShowModal: {
        type: Boolean,
        required: false,
        default: false
      },
      customShow: {
        type: Boolean,
        required: false,
        default: false
      },
      canEdit: {
        type: Boolean,
        required: false,
        default: true
      },
      canEditModal: {
        type: Boolean,
        required: false,
        default: false
      },
      canEditPenalty: {
        type: Boolean,
        required: false,
        default: false
      },
      canRepair: {
        type: Boolean,
        required: false,
        default: false
      },
      canDelete: {
        type: Boolean,
        required: false,
        default: true
      },
      canShowPopover: {
        type: Boolean,
        required: false,
        default: true
      },
      canApprove: {
        type: Boolean,
        required: false,
        default: true
      },
      canReject: {
        type: Boolean,
        required: false,
        default: true
      },
      canPaid: {
        type: Boolean,
        required: false,
        default: true
      },
      canRemove: {
        type: Boolean,
        required: false,
        default: true
      },
      canEditType: {
        type: Boolean,
        required: false,
        default: true
      },
      canDownload: {
        type: Boolean,
        required: false,
        default: true
      },
      canPrint: {
        type: Boolean,
        required: false,
        default: true
      },
      canView: {
        type: Boolean,
        required: false,
        default: true
      },
      noActions: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        dataAccount: this.$store.getters['account/accountData'],
        isLoading: false,
        type: null,
        failedToGetData: false,
        name: this.$route.name,
        uuidType: null,
        urlName: null,
        modelUuid: null,
        itemUuid: null,
        pagination: {
          // dataLimit: 20,
          currentPage: this.$route.query.page !== undefined ? parseInt(this.$route.query.page) : 1,
          total: 0,
          order: null,
          ascending: 0
        },
        propsToSearch: ['name', 'email', 'age'],
        tableColumns: [],
        tableData: [],
        roleList: [],
         //formatter curency
        money: {
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        statusList: [
          {
            value: '',
            text: 'Select Status',
          },
          {
            value: 'CANCELED',
            text: 'Canceled'
          },
          {
            value: 'CREATED',
            text: 'Created'
          },
          {
            value: 'PAID',
            text: 'Paid'
          },
          {
            value: 'UNPAID',
            text: 'Unpaid'
          },
        ],
        formData: {
          name: null,
          note: null,
          quotaExceed: null,
          days: null,
          status: 'CANCELED',
          requestedBy: null,
          startDate: null,
          endDate: null,
          deliveryDate: null,
          amount: null,
          billNumber: null,
          photoBill1: null,
          paymentAmmount: null,
          paymentReceipt: null,
          paymentTo: null,
          paymentDate: null,
          paymentNote: '',
          paymentRefNumber: null,
          changedBy: this.$store.getters['account/accountData'].uuid,
        },
        customSlots: [],
        bankList: [
          {
            value: '',
            text: 'Select Bank Account'
          }
        ],
      }
    },
    computed: {
      from () {
        return this.dataLimit * (this.pagination.currentPage - 1)
      },
      to () {
        let highBound = this.from + this.dataLimit
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      }
    },
    watch: {
      'pagination.currentPage' () {
        this.getDataTable()
      }
    },
    methods: {
      tableRow(item, type) {
        if (!item || type !== 'row') return
        if (item.repair !== undefined && item.repair !== null && this.$route.name !== 'Repair' || item.quotaExceed > null) return 'table-danger'
        else if (item.repair !== undefined && item.repair !== null && this.$route.name === 'Repair') return false
      },
      initData () {
        const t = this
        return {
          params () {
            return new Promise((resolve, reject) => {
              t.pagination.order = t.$route.query.order !== undefined ? t.$route.query.order : t.dataOrderField
              t.pagination.ascending = parseInt(t.$route.query.ascending !== undefined ? t.$route.query.ascending : t.dataOrderAsc)
              resolve('done')
            })
          }
        }
      },
      setData () {
        const t = this
        return {
          params (replaceOnly = false, addititonalData = []) {
            let arrayParams = {}
            arrayParams['limit'] = t.dataLimit
            arrayParams['order'] = t.dataOrderField
            arrayParams['page'] = t.pagination.currentPage
            // arrayParams['order'] = t.pagination.order
            // arrayParams['ascending'] = t.pagination.ascending
            t.dataParams.forEach((key) => {
              if (addititonalData[key] !== undefined) {
                if (addititonalData[key] !== '' && addititonalData[key] !== null) {
                  arrayParams[key] = addititonalData[key]
                }
              } else if (t.$route.query[key] !== undefined) {
                arrayParams[key] = t.$route.query[key]
              } else if (t.defaultDataParams[key] !== undefined) {
                arrayParams[key] = t.defaultDataParams[key]
              }
            })
            t.$router.replace({path: t.$route.path, query: arrayParams}).catch(error => { if (error.name != "NavigationDuplicated") {throw error;} })
            if (!replaceOnly) {
              let stringParams = ''
              Object.keys(arrayParams).forEach((key) => {
                stringParams += (stringParams === '' ? '?' : '&') + key + '=' + arrayParams[key]
              })
              /* t.dataParams.forEach((key) => {
                if (addititonalData[key] !== undefined) {
                  if (addititonalData[key] !== '' && addititonalData[key] !== null) {
                    stringParams += '&' + key + '=' + addititonalData[key]
                  }
                } else if (t.$route.query[key] !== undefined) {
                  stringParams += '&' + key + '=' + t.$route.query[key]
                } else if (t.defaultDataParams[key] !== undefined) {
                  stringParams += '&' + key + '=' + t.defaultDataParams[key]
                }
              }) */
              return stringParams
            }
          }
        }
      },
      initTableColumns () {
        this.tableColumns = []
        for (let i = 0; i < this.dataColumns.length; i++) {
          this.tableColumns.push({
            prop: this.dataColumns[i].key,
            label: this.dataColumns[i].label === undefined || this.dataColumns[i].label === null ? this.dataColumns[i].key.charAt(0).toUpperCase() + this.dataColumns[i].key.slice(1) : this.dataColumns[i].label,
            minWidth: this.dataColumns[i].minWidth === undefined ? null : this.dataColumns[i].minWidth,
            sortable: this.dataColumns[i].sortable === undefined ? null : this.dataColumns[i].sortable,
            isToggle: this.dataColumns[i].isToggle === undefined ? null : this.dataColumns[i].isToggle,
            formatThisDate: this.dataColumns[i].formatThisDate === undefined ? false : this.dataColumns[i].formatThisDate,
            isNumeric: this.dataColumns[i].isNumeric === undefined ? false : this.dataColumns[i].isNumeric,
            hasCustomSlot: this.hasSlot('content_' + this.dataColumns[i].key),
            align: this.dataColumns[i].align === undefined ? 'left' : this.dataColumns[i].align,
            needCurrency: this.dataColumns[i].needCurrency === undefined ? false : this.dataColumns[i].needCurrency
          })
        }
      },
      getDataTable (params = []) {
        this.isLoading = true
        this.failedToGetData = false
        this.$http.get(this.dataUrl + (this.dataUrl.indexOf('?') !== -1 ? '&' + this.setData().params(false, params).substr(1) : this.setData().params(false, params))).then(response => {
          this.tableData = response.data._embedded[this.dataKey]
          this.pagination.total = response.data.total_items
          this.isLoading = false
          let toggleDatas = []
          this.tableColumns.forEach((tableColumn) => {
            if (tableColumn.isToggle) {
              toggleDatas.push(tableColumn.prop)
            }
          })
          // this.pagination.currentPage = response.data.page
        }).catch(error => {
          window.consoleLog(error)
          this.isLoading = false
          this.failedToGetData = true
          // this.$SmoothScroll(this.$el.querySelector('#dataTable'))
        })
      },
      generateTemplateSlot () {
        this.customSlots = []
        this.dataColumns.forEach(fieldColumn => {
          if (this.hasSlot('content_' + fieldColumn.key)) {
            this.customSlots.push(fieldColumn)
          }
        })
      },
      setPage (page) {
        this.pagination.currentPage = page
      },
      onChangePage () {
        this.getDataTable()
      },
      doSorting (column) {
        this.$refs.paginatedTable.sort(column, this.pagination.order !== column ? 'ascending' : (!this.pagination.ascending ? 'ascending' : 'descending'))
      },
      doFilter (params) {
        this.setPage(1)
        this.setData().params(true, params)
        this.getDataTable(params)
      },
      doEdit (row) {
        row.type = 'Edit'
        this.$emit('editData', row)
      },
      doShowModal (row) {
        row.type = 'Details'
        this.$emit('detailsData', row)
      },
      onSortChange (column) {
        if (column.prop !== null && column.order) {
          this.pagination.order = column.prop
          this.pagination.ascending = column.order === 'ascending' ? 1 : 0
          this.setData().params(true)
        }
      },
      doDeleteData (uuid) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this data!',
          icon: "warning",
          buttons: true,
          dangerMode: true,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            this.$http.delete((this.deleteUrl !== null ? this.deleteUrl : this.dataUrl) + '/' + uuid).then(response => {
              this.$store.dispatch('notification/success', 'Successfully deleted.')
              this.getDataTable()
              this.$emit('afterDeleteData', uuid)
            }).catch(error => {
              this.$store.dispatch('notification/error', 'Failed To Delete Data.')
              window.consoleLog(error)
            })
          }
        })
      },
      doDeleteAccess (uuid) {
        this.$http.delete((this.deleteUrl !== null ? this.deleteUrl : this.dataUrl) + '/' + uuid).then(response => {
          this.$store.dispatch('notification/success', 'Access data successfully deleted.')
          this.getDataTable()
          this.$emit('afterDeleteData', uuid)
        }).catch(error => {
          // this.$store.dispatch('notification/error', 'Failed To Delete Data.')
          // window.consoleLog(error)
          swal("There's something wrong!", "Sorry, you don't have permission to remove this data", "error", {
            buttons: false,
            timer: 3000
          });
          this.doFilter()
        })
      },
      doCancelData (uuid) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will cancel the vehicle request on this vehicle!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonClass: 'btn btn-danger mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$http.patch(window.AppConfig.apiUrl + 'vehicle' + '/' + uuid, {'status': '1'})
            .then(response => {
              this.getDataTable()
              this.$store.dispatch('notification/success', 'Successfully updated.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },

      doDeleteDataCash(uuid){
      this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this data!',
          icon: "warning",
          buttons: true,
          dangerMode: true,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            this.$http.delete(window.AppConfig.apiUrl + 'cash' + '/' + uuid).then(response => {
              this.$store.dispatch('notification/success', 'Successfully deleted.')
              this.getDataTable()
            }).catch(error => {
              this.$store.dispatch('notification/error', 'Failed To Delete Data.')
              window.consoleLog(error)
            })
          }
        })
    },

      cancelInvoice(){},

      doCancelInvoice(model){
        this.$swal({
          title: 'Are you sure?',
          text: 'You will cancel the Invoice request!',
          icon: "info",
          buttons: true,
          dangerMode: false,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            let data = {}
            data["uuid"],
            data["CANCELED"] = model[1] ? 1 : 0,
            data[this.$store.getters['account/accountData'].uuid]
            this.$http.post(window.AppConfig.apiUrl + 'invoice-status', data, {'status': '1'})
            .then(response => {
              console.log(data);
              this.getDataTable()
              this.$store.dispatch('notification/success', 'Successfully canceled.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      },
      hasSlot (name = 'default') {
        return !!this.$slots[name] || !!this.$scopedSlots[name]
      },
      hasRole (name) {
        let temp = false
        name.forEach((key) => {
          if (this.$store.getters['account/accountData'].role == key){
            temp = true
          }
        })
        return temp
      },
      formatDate (date) {
        return this.$moment(date).format(window.AppConfig.dateFormat)
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      formatDays(value) {
        let val = (value/1).toFixed(1).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      getLastPathUrl () {
        let tmp = this.$route.matched[this.$route.matched.length - 2].path
        if (tmp === '' || tmp.slice(-1) !== '/') tmp += '/'
          return '#' + tmp
      },
      getStatusColor (val) {
        switch (val) {
          case 'Requested':
            return 'info'
            // eslint-disable-next-line no-unreachable
            break
          case 'New':
            return 'info'
            // eslint-disable-next-line no-unreachable
            break
          case 'Returning':
            return 'info'
            // eslint-disable-next-line no-unreachable
            break
          case 'Approved':
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 'Done':
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break
          case 'Completed':
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 'Rejected':
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
          case 'Paid':
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break
          case 'Finished':
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 'Issued':
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break
          case 'CREATED':
            return 'warning'

          case 'UNPAID':
            return 'danger'

          // eslint-disable-next-line no-duplicate-case
          case 'PAID':
            return 'primary'

          case 'CANCELED':
            return 'secondary'

          case 'Created':
            return 'warning'

          case 'Cancel':
            return 'secondary'

          case 'Shipping':
            return 'success'

          case 'Received':
            return 'primary'

          case 'In Progress':
            return 'warning'

          case 'Returned':
            return 'secondary'


          case false:
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break
          case true:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case '0':
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
          case '1':
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusName (val) {
        switch (val) {
          case '0':
            return 'Not Available'
            // eslint-disable-next-line no-unreachable
            break
          case '1':
            return 'Available'
            // eslint-disable-next-line no-unreachable
            break
          case false:
            return 'Optional'
            // eslint-disable-next-line no-unreachable
            break
          case true:
            return 'Required'
            // eslint-disable-next-line no-unreachable
            break
          case 'New':
            return 'Waiting For Payment'
            // eslint-disable-next-line no-unreachable
            break
          case 'Paid':
            return 'Paid'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusTypeColor (val) {
        switch (val) {
          case 'New':
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break
          case 'Paid':
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusTypeName (val) {
        switch (val) {
          case 'New':
            return 'Waiting For Payment'
            // eslint-disable-next-line no-unreachable
            break
          case 'Paid':
            return 'Paid'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusJobsName(val){
        switch (val) {
          case 'New':
            return 'In Progress'
            // eslint-disable-next-line no-unreachable
            break
          case 'Completed':
            return 'Finished'
            // eslint-disable-next-line no-unreachable
            break

          case 'Finished':
            return 'Finished'
            // eslint-disable-next-line no-unreachable
            break

           case 'In Progress':
            return 'In Progress'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusNameGeofence(val){
        switch(val){
          case true:
            return 'YES';

          case false:
            return 'NO';

          case 1:
            return 'YES';

          case 0:
            return 'NO';
        }
      },
      getStatusJobsColor(val){
        switch(val){
          case 'In Progress':
            return 'warning'
            // eslint-disable-next-line no-unreachable
            break

          case 'Created':
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break

          case 'New':
            return 'warning'
            // eslint-disable-next-line no-unreachable
            break

          case 'Finished':
            return 'success'
            // eslint-disable-next-line no-unreachable
            break

          case 'Completed':
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
       getStatusWorksColor(val){
        switch(val){
          case 'In Progress':
            return 'warning'
            // eslint-disable-next-line no-unreachable
            break

          case 'Created':
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break

          case 'Solved':
            return 'success'
            // eslint-disable-next-line no-unreachable
            break

          case 'Done':
            return 'primary'
            // eslint-disable-next-line no-unreachable
            break

        }
      },
      getStatusTypeRepair (val) {
        switch (val) {
          case 'New':
            return 'Requested'
            // eslint-disable-next-line no-unreachable
            break
          case 'Paid':
            return 'Paid'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusQrcode (val) {
        switch (parseInt(val)) {
          case 0:
            return 'Not Available'
            break
          case 1:
            return 'Available'
            break
        }
      },
      getColorCompany (val) {
        switch (val) {
          case false:
            return ''
            // eslint-disable-next-line no-unreachable
            break
          case true:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 0:
            return 'danger'
            break
          case 1:
            return 'success'
            break
        }
      },
      getNameLeave (val){
        switch (val) {
          case 'Requested':
            return this.$root.$t('req')
          case 'Canceled':
            return this.$root.$t('can')
          case 'Approved':
            return this.$root.$t('appr');
          case 'Rejected':
            return this.$root.$t('rej')
        }
      },
      getStatusCompany (val) {
        switch (val) {
          case false:
            return ''
            // eslint-disable-next-line no-unreachable
            break
          case true:
            return 'HQ'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusCompanyName (val) {
        switch (val) {
          case '0':
            return 'Not Active'
            // eslint-disable-next-line no-unreachable
            break
          case '1':
            return 'Active'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      doChangeStatusAvailable(model) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will change vehicle status to be available!',
          icon: "info",
          buttons: true,
          dangerMode: false,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            let data = {}
            data["uuid"] = model[0]
            data["is_active"] = model[1] ? 1 : 0
            this.$http.post(window.AppConfig.apiUrl + 'vehicle-status-action', data)
            .then((response) => {
              this.$swal.close()
              this.getDataTable()
              this.$store.dispatch('notification/success',  'Vehicle status has been changed')
            })
            .catch(error => {
                this.$store.dispatch('notification/error', error)
            });
          }
        })
      },
      doChangeStatusNotAvailable(model) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will change vehicle status to be not available!',
          icon: "info",
          buttons: true,
          dangerMode: false,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            let data = {}
            data["uuid"] = model[0]
            data["is_active"] = model[1] ? 0 : 1
            this.$http.post(window.AppConfig.apiUrl + 'vehicle-status-action', data)
            .then((response) => {
              this.$swal.close()
              this.getDataTable()
              this.$store.dispatch('notification/success',  'Vehicle status has been changed')
            })
            .catch(error => {
                this.$store.dispatch('notification/error', error)
            });
          }
        })
      },
      showModalTypePay(type, row) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will make a pay transaction on this vehicle!',
          icon: "info",
          buttons: true,
          dangerMode: false,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            let model = {
              uuid: row.uuid,
              amount: row.amount,
              billNumber: row.billNumber,
              note: row.note
            }
            let formData = new FormData()
            formData.append('uuid', model.uuid)
            formData.append('billNumber', model.billNumber)
            formData.append('amount', model.amount)
            formData.append('note', model.note)
            this.$http.post(window.AppConfig.apiUrl + 'vehicle-paid-bill', formData)
            .then((response) => {
              this.$swal.close()
              this.getDataTable()
              this.$store.dispatch('notification/success', type + ' data has been paid')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
            });
          }
        })
      },
      showModalPayRepair (type, row) {
        // this.formData.note = null
        this.type = type
        this.formData.billNumber = row.billNumber
        this.formData.photoBill1 = row.vehicleBillPhoto
        this.modelUuid = row.uuid
        this.formData.amount = row.amount
        this.$bvModal.show('bv-modal-type')
      },

      // showModalPayInvoice (type, row) {
      //   this.type = type
      //   this.formData.paymentDate = row.paymentDate
      //   this.formData.paymentRefNumber = row.paymentRefNumber
      //   this.formData.paymentAmmount = row.paymentAmmount
      //   this.formData.paymentNote = row.paymentNote
      //   this.formData.changedBy
      //   this.modelUuid = row.uuid
      //   this.$bvModal.show('bv-modal-invoice')
      // },


      doChangeStatusType (type) {
        this.isLoading = true
        let formData = new FormData()
        formData.append('uuid', this.modelUuid)
        formData.append('billNumber', this.formData.billNumber)
        formData.append('amount', this.formData.amount)
        // formData.append('note', this.formData.note)
        if (this.formData.photoBill1 !== null) {
          formData.append('photoBill1', this.formData.photoBill1, this.formData.photoBill1.name)
        }
        this.$http.post(window.AppConfig.apiUrl + 'vehicle-paid-bill', formData).then((resp) => {
          this.isLoading = false
          this.getDataTable()
          this.$bvModal.hide('bv-modal-type')
          this.$store.dispatch('notification/success', type + ' data has been paid')
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },
      // },
      // showModalTypePay (type, row) {
      //   this.formData.note = null
      //   this.type = type
      //   this.formData.billNumber = row.billNumber
      //   this.modelUuid = row.uuid
      //   this.formData.amount = row.amount
      //   this.$bvModal.show('bv-modal-type')
      // },
      // doChangeStatusType (type) {
      //   this.isLoading = true
      //     if (type === 'Road Tax') {
      //       this.type = 'Road Tax'
      //     } else if (type === 'Service') {
      //       this.type = 'Service'
      //     } else {
      //       this.type = 'Penalty'
      //     }
      //     let formData = new FormData()
      //     formData.append('uuid', this.modelUuid)
      //     formData.append('billNumber', this.formData.billNumber)
      //     formData.append('amount', this.formData.amount)
      //     formData.append('note', this.formData.note)
      //     this.$http.post(window.AppConfig.apiUrl + 'vehicle-paid-bill', formData).then((resp) => {
      //       this.isLoading = false
      //       this.getDataTable()
      //       this.$bvModal.hide('bv-modal-type')
      //       this.$store.dispatch('notification/success', type + ' data has been paid')
      //     })
      //     .catch(error => {
      //       this.isLoading = false
      //       this.$store.dispatch('notification/error', error)
      //     });
      //   //  else {
      //   //   let formData = new FormData()
      //   //   formData.append('uuid', this.modelUuid)
      //   //   formData.append('amount', this.formData.amount)
      //   //   formData.append('billNumber', this.formData.billNumber)
      //   //   if (this.model.photoBill1 !== null) {
      //   //     formData.append('photoBill1', this.model.photoBill1, this.model.photoBill1.name)
      //   //   }
      //   //   this.$http.post(window.AppConfig.apiUrl + 'vehicle-paid-bill', formData).then((resp) => {
      //   //     this.isLoading = false
      //   //     this.formData.note = null
      //   //     this.getDataTable()
      //   //     this.$bvModal.hide('bv-modal-type')
      //   //     this.$store.dispatch('notification/success', 'Repair has been paid')
      //   //   })
      //   //   .catch(error => {
      //   //     this.isLoading = false
      //   //     this.$store.dispatch('notification/error', error)
      //   //   });
      //   // }
      // },
      // showModalTypePayf(type) {
      //   this.$swal({
      //     title: 'Are you sure?',
      //     text: 'You will make a road tax pay transaction on this vehicle!',
      //     icon: "info",
      //     buttons: true,
      //     dangerMode: false,
      //     buttonsStyling: false,
      //   }).then(result => {
      //     if (result) {
      //       this.formData.uuidType = this.modelUuid
      //       this.type = type
      //       let formData = new FormData()
      //       formData.append('uuid', this.formData.uuidType)
      //       this.$http.post(window.AppConfig.apiUrl + 'vehicle-paid-bill', formData)
      //       .then((response) => {
      //         this.$swal.close()
      //         this.getDataTable()
      //         this.$store.dispatch('notification/success',  'Road tax has been paid')
      //       })
      //       .catch(error => {
      //           this.$store.dispatch('notification/error', error)
      //       });
      //     }
      //   })
      // },
      changeRole (model, uuid) {
        let roleUuid = model[0]
        let data = {}

        data["userProfile"] = model[1]
        data["userRole"] = model[2]
        this.$http.patch(window.AppConfig.apiUrl + 'user-access' + '/' + roleUuid, data)
        .then(response => {
          this.doFilter()
          this.$store.dispatch('notification/success', 'Access data successfully updated.')
        })
        .catch(error => {
          // this.$store.dispatch('notification/error', error)
          swal("There's something wrong!", "Sorry, you don't have permission to change this data", "error", {
            buttons: false,
            timer: 3000
          });
          this.doFilter()
        })
      },
      changeSwitch (model) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will change the status!',
          icon: "info",
          buttons: true,
          dangerMode: false,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            let data = {}
            data["uuid"] = model[0]
            data["level"] = model[1]
            data["isActive"] = model[2] ? 0 : 1
            this.$http.post(window.AppConfig.apiUrl + 'division-company', data)
            .then(response => {
              this.$swal.stopLoading()
              this.$swal.close()
              this.doFilter()
              this.$store.dispatch('notification/success', 'Status Successfully updated.')
            })
            .catch(error => {
              this.$swal.stopLoading()
              this.$swal.close()
              const filteredTableData = this.tableData.filter((data) => {
                return data.uuid === model[0]
              })
              filteredTableData[0].isActive = model[2]
              this.$store.dispatch('notification/error', error)
            })
          } else {
            const filteredTableData = this.tableData.filter((data) => {
              return data.uuid === model[0]
            })
            filteredTableData[0].isActive = model[2]
          }
        })
      },
      changeLeaveType (model) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will change the status!',
          icon: "info",
          buttons: true,
          dangerMode: false,
          buttonsStyling: false,
        }).then(result => {
          if (result) {
            let data = {}
            data["isActive"] = model[1] ? 0 : 1
            let uuidLeave = model[0]
            this.$http.patch(window.AppConfig.apiUrl + 'leave-type/' + uuidLeave, data)
            .then(response => {
              this.$swal.stopLoading()
              this.$swal.close()
              this.doFilter()
              this.$store.dispatch('notification/success', 'Status Successfully updated.')
            })
            .catch(error => {
              this.$swal.stopLoading()
              this.$swal.close()
              const filteredTableData = this.tableData.filter((data) => {
                return data.uuid === model[0]
              })
              filteredTableData[0].isActive = model[1]
              this.$store.dispatch('notification/error', error)
            })
          } else {
            const filteredTableData = this.tableData.filter((data) => {
              return data.uuid === model[0]
            })
            filteredTableData[0].isActive = model[1]
          }
        })
      },
      getDateTime (value, format="DD MMM YYYY hh:mm A") {
        return this.$moment(value).format(format)
      },
      getDate (value, format="DD MMM YYYY") {
        return this.$moment(value).format(format)
      },
      getTime(value, format="hh:mm A"){
        return this.$moment(value).format(format)
      },
      showModalSales (type, row) {
        this.formData.deliveryDate = ''
        this.formData.note = null
        this.type = type
        if (this.$route.name === 'Sales Order') {
          this.urlName = 'sales-action'
        }
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-sales')
      },
      doDeliverySales (type) {
        this.$http.post(window.AppConfig.apiUrl + this.urlName, {
          uuid: this.modelUuid,
          action: type,
          deliveryDate: this.formData.deliveryDate,
          type: 'sales-order',
          note: this.formData.note
        })
        .then((resp) => {
          this.isLoading = false
          this.formData.deliveryDate = ''
          this.formData.note = null
          this.getDataTable()
          this.$bvModal.hide('bv-modal-sales')
          this.$store.dispatch('notification/success', this.$route.name + ' has been approved')
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },
      showModalLeaves (type, row) {
        this.formData.note = null
        this.type = type
        if (this.$route.name === 'Detail Employee') {
          this.urlName = 'leave-action'
        }
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-leaves')
      },
      doChangeStatusLeaves (type) {
        this.isLoading = true
        this.$http.post(window.AppConfig.apiUrl + this.urlName, {
          uuid: this.modelUuid,
          action: type,
          note: this.formData.note
        })
        .then((resp) => {
          this.isLoading = false
          this.formData.note = null
          this.getDataTable()
          this.$bvModal.hide('bv-modal-leaves')
          if (type === 'reject') {
            this.$store.dispatch('notification/success', 'Leave has been ' + type + 'ed')
          } else {
            this.$store.dispatch('notification/success', 'Leave has been ' + type + 'd')
          }
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },
      showLeavesModal (type, row) {
        this.formData.note = null
        this.formData.name = row.requestedBy.name
        this.formData.days = row.days
        this.formData.quotaExceed = row.quotaExceed ? row.quotaExceed : '-'
        this.type = type
        if (this.$route.name === 'Leave') {
          this.urlName = 'leave-action'
        }
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-leaves-index')
      },
      doLeavesChangeStatus (type) {
        this.isLoading = true
        this.$http.post(window.AppConfig.apiUrl + this.urlName, {
          uuid: this.modelUuid,
          action: type,
          note: this.formData.note
        })
        .then((resp) => {
          this.isLoading = false
          this.formData.note = null
          this.getDataTable()
          this.$bvModal.hide('bv-modal-leaves-index')
          if (type === 'reject') {
            this.$store.dispatch('notification/success', 'Leave has been ' + type + 'ed')
          } else {
            this.$store.dispatch('notification/success', 'Leave has been ' + type + 'd')
          }
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },
      showModalInvoicePay (row) {
        this.formData.paymentDate = null
        this.formData.paymentRefNumber = null
        this.formData.paymentTo = null
        this.formData.paymentAmmount = null
        this.formData.paymentReceipt = ''
        this.formData.paymentNote = ''
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-invoice-pay')
        this.getBankList()
      },

       showModalPurchasePay (row) {
        this.formData.paymentDate = null
        this.formData.paymentRefNumber = ''
        this.formData.paymentTo = null
        this.formData.paymentAmmount = 0
        this.formData.paymentNote = ''
        this.formData.paymentReceipt = ''
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-purchase-pay')
        this.getBankList()
      },

      showModalInvoicePaid (row) {
        this.formData.status = 'PAID'
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-invoice')
      },
      showModalInvoice (row) {
        this.formData.status = 'CANCELED'
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-invoice')
      },

      showModalReceipt(row) {
        this.formData.status = 'Canceled'
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-receipt')
      },
      doChangeStatusReceipt () {
        this.isLoading = true
        this.$http.post(window.AppConfig.apiUrl + 'receipt-status', {
          receipt: this.modelUuid,
          status: this.formData.status,
        })
        .then((resp) => {
          this.isLoading = false
          this.formData.note = null
          this.formData.status = null
          this.getDataTable()
          this.$bvModal.hide('bv-modal-receipt')
          this.$store.dispatch('notification/success', 'Delivery Order status has been changed')
         
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },

      doChangeStatusInvoice () {
        this.isLoading = true
        this.$http.post(window.AppConfig.apiUrl + 'invoice-status', {
          invoice: this.modelUuid,
          status: this.formData.status,
          note: this.formData.note,
          changedBy: this.formData.changedBy,
        })
        .then((resp) => {
          this.isLoading = false
          this.formData.note = null
          this.formData.status = null
          this.getDataTable()
          this.$bvModal.hide('bv-modal-invoice')
          this.$store.dispatch('notification/success', 'Invoice status has been changed')
         
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },

        doPaymentInvoice(){
        this.$validator.validateAll().then((res)=> {
          if(res){
            this.isLoading = true
            let formData = new FormData()
            formData.append('invoice', this.modelUuid)
            formData.append('paymentDate', this.formData.paymentDate)
            formData.append('paymentRefNumber', this.formData.paymentRefNumber)
            formData.append('paymentTo', this.formData.paymentTo)
            formData.append('paymentAmmount', this.formData.paymentAmmount)
            formData.append('paymentReceipt', this.formData.paymentReceipt)
            formData.append('paymentNote', this.formData.paymentNote)
            formData.append('changedBy', this.formData.changedBy)
            this.$http.post(window.AppConfig.apiUrl + 'invoice-payment', formData).then((response) => {
              this.isLoading = false
              this.$bvModal.hide('bv-modal-invoice-pay')
              this.$store.dispatch('notification/success', 'Success')
              this.getDataTable()
              window.location.reload()
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          } else {
            // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
          }
        })
      },

        /**
         * Submit payment Purchase
         */
       doPaymentPurchase(){
        this.$validator.validateAll().then((res)=> {
          if(res){
            this.isLoading = true
            let formData = new FormData()
            formData.append('purchase', this.modelUuid)
            formData.append('paymentDate', this.formData.paymentDate)
            formData.append('paymentRefNumber', this.formData.paymentRefNumber)
            formData.append('paymentTo', this.formData.paymentTo)
            formData.append('paymentAmmount', this.formData.paymentAmmount)
            formData.append('paymentReceipt', this.formData.paymentReceipt)
            formData.append('paymentNote', this.formData.paymentNote)
            formData.append('changedBy', this.formData.changedBy)
            this.$http.post(window.AppConfig.apiUrl + 'purchase-history-payment', formData).then((response) => {
              this.isLoading = false
              this.$bvModal.hide('bv-modal-purchase-pay')
              this.$store.dispatch('notification/success', 'Success')
              this.getDataTable()
              // window.location.reload()
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          } else {
            // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
          }
        })
      },
      
      showModalOvertime (type, row) {
        this.formData.note = null
        this.type = type
        if (this.$route.name === 'Detail Employee') {
          this.urlName = 'overtime-action'
        }
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-overtimes')
      },
      doChangeStatusOvertime (type) {
        this.isLoading = true
        this.$http.post(window.AppConfig.apiUrl + this.urlName, {
          uuid: this.modelUuid,
          action: type,
          note: this.formData.note
        })
        .then((resp) => {
          this.isLoading = false
          this.formData.note = null
          this.getDataTable()
          this.$bvModal.hide('bv-modal-overtimes')
          if (type === 'reject') {
            this.$store.dispatch('notification/success', 'Overtime has been ' + type + 'ed')
          } else {
            this.$store.dispatch('notification/success', 'Overtime has been ' + type + 'd')
          }
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        });
      },
      
      showModal (type, row) {
        this.formData.note = null
        this.type = type
        if (this.$route.name === 'Overtime') {
          this.urlName = 'overtime-action'
        } else if (this.$route.name === 'Sales Order') {
          this.urlName = 'sales-action'
        } else if (this.$route.name === 'Requested Reimbursement') {
          this.urlName = 'reimbursement-action'
        } else if (row.type === "Penalty" && row.type === "Repair" && type === 'paid') {
          this.urlName = 'vehicle-paid-bill'
        } else if (this.$route.name === 'Quotation') {
          this.urlName = 'quotation-action'
        }
         else {
          this.urlName = 'leave-action'
        }
        this.modelUuid = row.uuid
        this.$bvModal.show('bv-modal-example')
      },
      
      doChangeStatus (type) {
        this.isLoading = true
        if (type === 'paid') {
          this.$http.post(window.AppConfig.apiUrl + this.urlName, {
            uuid: this.modelUuid
          })
          .then((resp) => {
              this.isLoading = false
              this.formData.note = null
              this.getDataTable()
              this.$bvModal.hide('bv-modal-payment')
              this.$store.dispatch('notification/success', this.$route.name + ' has been ' + type + 'ed')
          })
          .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
          });
        } else {
          this.$http.post(window.AppConfig.apiUrl + this.urlName, {
              uuid: this.modelUuid,
              action: type,
              note: this.formData.note
          })
          .then((resp) => {
              this.isLoading = false
              this.formData.note = null
              this.getDataTable()
              this.$bvModal.hide('bv-modal-example')
              this.$store.dispatch('notification/success', this.$route.name + ' has been ' + type + 'ed')
          })
          .catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
          });
        }
      },
      doDownloadQRcode(row){
        let data = row
        const url = window.URL.createObjectURL(new Blob(['http://dev.xtend.my.id/qrcode' + data + '.png'], {type: "image/png"}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'qrcode.png') //or any other extension
        document.body.appendChild(link)
        link.click()
      },
      doPrintQRcode (row) {
        var urlQrCode = row
        var win = window.open('' )
        var img=win.document.createElement("img")
        img.src= urlQrCode
        win.document.body.appendChild(img)
        img.onload = function(){
          // win.open()
          win.print()
        }
      },
      showQRCode(row) {
        var data = row
        const h = this.$createElement
        const titleVNode = h('div', { domProps: { innerHTML: 'Scan Your QR Code Here!' } })
        const messageVNode = h('div', { class: ['foobar'] }, [
          h('b-img', {
            props: {
              src: data,
              thumbnail: true,
              center: true,
              fluid: true, rounded: 'rectangle'
            }
          })
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          buttonSize: 'sm',
          centered: true, size: 'sm'
        })
      },
      getRoleName() {
        this.$http.get(window.AppConfig.apiUrl + 'user-role').then(response => {
          response.data._embedded.user_role.forEach(data => {
            this.roleList.push({
              value: data.uuid,
              text: data.name
            })
          })
        })
      },
       //get bank account
      getBankList() {
        this.$http.get(window.AppConfig.apiUrl + 'bank-account').then((response) => {
          this.bankList = [];
          response.data._embedded.bank_account.forEach((data)=> {
            this.bankList.push({
              value: data.uuid,
              text: data.bank
            })
          })
        }).catch(error =>{
            window.consoleLog(error);
        })
      },

      // getCustomerCompany() {
      //   this.$http.get(window.AppConfig.apiUrl + 'customer').then(response => {
      //     response.data._embedded.customer.forEach(data => {
      //       if (data.customerCompany !== null) {
      //         data.customerCompany.forEach(data => {
      //           this.companyList.push({
      //             value: data.uuid,
      //             text: data.name
      //           })
      //         })
      //       }
      //     })
      //   })
      // },
      // doDownloadQRcode (row) {
      //   var FileSaver = require('file-saver')
      //   // var blob = new Blob(["hello world"], {type: "image/png"});
      //   let data = row
      //   FileSaver.saveAs(data)
      // },
      // doPrintQrcode() {
      //   let url = window.AppConfig.apiUrl + '' + '?token=' + this.$store.getters['account/tokens'].access_token
      //   window.print(url)
      //   // var qrcode = window.open(url);
      //   // qrcode.print();
      //   // var qrcode = window.open(url, '_blank', 'fullscreen=1,channelmode=1,status=1,resizable=1');
      //   // qrcode.focus();
      //   // qrcode.print();
      // },
      // showModalPay (type, row) {
      //   this.formData.requestedBy = row.requestedBy.name
      //   this.formData.requestedByUuid = row.requestedBy.uuid
      //   this.formData.startDate = null
      //   this.formData.endDate = null
      //   this.type = type
      //   if (this.$route.name === 'Payment Reimbursement') {
      //     this.urlName = 'paid-reimburse'
      //   }
      //   this.modelUuid = row.uuid
      //   this.$bvModal.show('bv-modal-payment')
      // },
      // doChangeStatusPay (type) {
      //   this.isLoading = true
      //   this.$http.post(window.AppConfig.apiUrl + this.urlName, {
      //       uuid: this.modelUuid,
      //       action: type,
      //       requestedBy: this.formData.requestedByUuid,
      //       startDate: this.formData.startDate,
      //       endDate: this.formData.endDate
      //   })
      //   .then((resp) => {
      //       this.isLoading = false
      //       this.formData.requestedBy = null
      //       this.formData.startDate = null
      //       this.formData.endDate = null
      //       this.getDataTable()
      //       this.$bvModal.hide('bv-modal-payment')
      //       this.$store.dispatch('notification/success', this.$route.name + ' has been paid')
      //   })
      //   .catch(error => {
      //       this.isLoading = false
      //       this.$store.dispatch('notification/error', error)
      //   });
      // }
    },
    mounted () {
      // this.getBankList()
      this.generateTemplateSlot()
      this.initData().params().then(() => {
        this.initTableColumns()
        this.getDataTable()
        this.getRoleName()
        // this.getCustomerCompany()
      })
    }
  };
</script>